import {getExtensionFromFilename} from './fileUtils';

type MimeType = string;
type Extension = string;

type MimeTypesMap = Record<MimeType, Extension[]>;

export function getMimeTypesMap(): MimeTypesMap {
    return {
        'application/acrobat': ['pdf'],
        'application/andrew-inset': ['ez'],
        'application/annodex': ['anx'],
        'application/appinstaller': ['appinstaller'],
        'application/applixware': ['aw'],
        'application/appx': ['appx'],
        'application/appxbundle': ['appxbundle'],
        'application/atom+xml': ['atom'],
        'application/atomcat+xml': ['atomcat'],
        'application/atomdeleted+xml': ['atomdeleted'],
        'application/atomsvc+xml': ['atomsvc'],
        'application/atsc-dwd+xml': ['dwd'],
        'application/atsc-held+xml': ['held'],
        'application/atsc-rsat+xml': ['rsat'],
        'application/automationml-aml+xml': ['aml'],
        'application/automationml-amlx+zip': ['amlx'],
        'application/bat': ['bat'],
        'application/bdoc': ['bdoc'],
        'application/buildstream+yaml': ['bst'],
        'application/bzip2': ['bz2', 'bz'],
        'application/calendar+xml': ['xcs'],
        'application/cbor': ['cbor'],
        'application/ccxml+xml': ['ccxml'],
        'application/cdfx+xml': ['cdfx'],
        'application/cdmi-capability': ['cdmia'],
        'application/cdmi-container': ['cdmic'],
        'application/cdmi-domain': ['cdmid'],
        'application/cdmi-object': ['cdmio'],
        'application/cdmi-queue': ['cdmiq'],
        'application/cdr': ['cdr'],
        'application/coreldraw': ['cdr'],
        'application/cpl+xml': ['cpl'],
        'application/csv': ['csv'],
        'application/cu-seeme': ['cu'],
        'application/cwl': ['cwl'],
        'application/dash+xml': ['mpd'],
        'application/dash-patch+xml': ['mpp'],
        'application/davmount+xml': ['davmount'],
        'application/dbase': ['dbf'],
        'application/dbf': ['dbf'],
        'application/dicom': ['dcm'],
        'application/docbook+xml': ['dbk', 'docbook'],
        'application/dssc+der': ['dssc'],
        'application/dssc+xml': ['xdssc'],
        'application/ecmascript': ['ecma', 'es'],
        'application/emf': ['emf'],
        'application/emma+xml': ['emma'],
        'application/emotionml+xml': ['emotionml'],
        'application/epub+zip': ['epub'],
        'application/exi': ['exi'],
        'application/express': ['exp'],
        'application/fdf': ['fdf'],
        'application/fdt+xml': ['fdt'],
        'application/fits': ['fits', 'fit', 'fts'],
        'application/font-tdpfr': ['pfr'],
        'application/font-woff': ['woff'],
        'application/futuresplash': ['swf', 'spl'],
        'application/geo+json': ['geojson', 'geo.json'],
        'application/gml+xml': ['gml'],
        'application/gnunet-directory': ['gnd'],
        'application/gpx': ['gpx'],
        'application/gpx+xml': ['gpx'],
        'application/gxf': ['gxf'],
        'application/gzip': ['gz'],
        'application/har+json': ['har'],
        'application/hjson': ['hjson'],
        'application/hta': ['hta'],
        'application/hyperstudio': ['stk'],
        'application/ico': ['ico'],
        'application/ics': ['vcs', 'ics', 'ifb', 'icalendar'],
        'application/illustrator': ['ai'],
        'application/inkml+xml': ['ink', 'inkml'],
        'application/ipfix': ['ipfix'],
        'application/its+xml': ['its'],
        'application/java': ['class'],
        'application/java-archive': ['jar', 'war', 'ear'],
        'application/java-byte-code': ['class'],
        'application/java-serialized-object': ['ser'],
        'application/java-vm': ['class'],
        'application/javascript': ['js', 'cjs', 'jsm', 'mjs'],
        'application/jrd+json': ['jrd'],
        'application/json': ['json', 'map'],
        'application/json-patch+json': ['json-patch'],
        'application/json5': ['json5'],
        'application/jsonml+json': ['jsonml'],
        'application/ld+json': ['jsonld'],
        'application/lgr+xml': ['lgr'],
        'application/lost+xml': ['lostxml'],
        'application/lotus123': ['123', 'wk1', 'wk3', 'wk4', 'wks'],
        'application/m3u': ['m3u', 'm3u8', 'vlc'],
        'application/mac-binhex40': ['hqx'],
        'application/mac-compactpro': ['cpt'],
        'application/mads+xml': ['mads'],
        'application/manifest+json': ['webmanifest'],
        'application/marc': ['mrc'],
        'application/marcxml+xml': ['mrcx'],
        'application/mathematica': ['ma', 'nb', 'mb'],
        'application/mathml+xml': ['mathml', 'mml'],
        'application/mbox': ['mbox'],
        'application/mdb': ['mdb'],
        'application/media-policy-dataset+xml': ['mpf'],
        'application/mediaservercontrol+xml': ['mscml'],
        'application/metalink+xml': ['metalink'],
        'application/metalink4+xml': ['meta4'],
        'application/mets+xml': ['mets'],
        'application/microsoftpatch': ['msp'],
        'application/microsoftupdate': ['msu'],
        'application/mmt-aei+xml': ['maei'],
        'application/mmt-usd+xml': ['musd'],
        'application/mods+xml': ['mods'],
        'application/mp21': ['m21', 'mp21'],
        'application/mp4': ['mp4', 'mpg4', 'mp4s', 'm4p'],
        'application/mrb-consumer+xml': ['xdf'],
        'application/mrb-publish+xml': ['xdf'],
        'application/ms-tnef': ['tnef', 'tnf'],
        'application/msaccess': ['mdb'],
        'application/msexcel': [
            'xls',
            'xlc',
            'xll',
            'xlm',
            'xlw',
            'xla',
            'xlt',
            'xld',
        ],
        'application/msix': ['msix'],
        'application/msixbundle': ['msixbundle'],
        'application/mspowerpoint': ['ppz', 'ppt', 'pps', 'pot'],
        'application/msword': ['doc', 'dot'],
        'application/msword-template': ['dot'],
        'application/mxf': ['mxf'],
        'application/n-quads': ['nq'],
        'application/n-triples': ['nt'],
        'application/nappdf': ['pdf'],
        'application/node': ['cjs'],
        'application/octet-stream': [
            'bin',
            'dms',
            'lrf',
            'mar',
            'so',
            'dist',
            'distz',
            'pkg',
            'bpk',
            'dump',
            'elc',
            'deploy',
            'exe',
            'dll',
            'deb',
            'dmg',
            'iso',
            'img',
            'msi',
            'msp',
            'msm',
            'buffer',
        ],
        'application/oda': ['oda'],
        'application/oebps-package+xml': ['opf'],
        'application/ogg': ['ogx'],
        'application/omdoc+xml': ['omdoc'],
        'application/onenote': ['onetoc', 'onetoc2', 'onetmp', 'onepkg'],
        'application/ovf': ['ova'],
        'application/owl+xml': ['owx'],
        'application/oxps': ['oxps'],
        'application/p2p-overlay+xml': ['relo'],
        'application/patch-ops-error+xml': ['xer'],
        'application/pcap': ['pcap', 'cap', 'dmp'],
        'application/pdf': ['pdf'],
        'application/pgp': ['pgp', 'gpg', 'asc'],
        'application/pgp-encrypted': ['pgp', 'gpg', 'asc'],
        'application/pgp-keys': ['asc', 'skr', 'pkr', 'pgp', 'gpg', 'key'],
        'application/pgp-signature': ['sig', 'asc', 'pgp', 'gpg'],
        'application/photoshop': ['psd'],
        'application/pics-rules': ['prf'],
        'application/pkcs10': ['p10'],
        'application/pkcs12': ['p12', 'pfx'],
        'application/pkcs7-mime': ['p7m', 'p7c'],
        'application/pkcs7-signature': ['p7s'],
        'application/pkcs8': ['p8'],
        'application/pkcs8-encrypted': ['p8e'],
        'application/pkix-attr-cert': ['ac'],
        'application/pkix-cert': ['cer'],
        'application/pkix-crl': ['crl'],
        'application/pkix-pkipath': ['pkipath'],
        'application/pkixcmp': ['pki'],
        'application/pls': ['pls'],
        'application/pls+xml': ['pls'],
        'application/postscript': ['ai', 'eps', 'ps'],
        'application/powerpoint': ['ppz', 'ppt', 'pps', 'pot'],
        'application/provenance+xml': ['provx'],
        'application/prs.cww': ['cww'],
        'application/prs.wavefront-obj': ['obj'],
        'application/prs.xsf+xml': ['xsf'],
        'application/pskc+xml': ['pskcxml'],
        'application/ram': ['ram'],
        'application/raml+yaml': ['raml'],
        'application/rdf+xml': ['rdf', 'owl', 'rdfs'],
        'application/reginfo+xml': ['rif'],
        'application/relax-ng-compact-syntax': ['rnc'],
        'application/resource-lists+xml': ['rl'],
        'application/resource-lists-diff+xml': ['rld'],
        'application/rls-services+xml': ['rs'],
        'application/route-apd+xml': ['rapd'],
        'application/route-s-tsid+xml': ['sls'],
        'application/route-usd+xml': ['rusd'],
        'application/rpki-ghostbusters': ['gbr'],
        'application/rpki-manifest': ['mft'],
        'application/rpki-roa': ['roa'],
        'application/rsd+xml': ['rsd'],
        'application/rss+xml': ['rss'],
        'application/rtf': ['rtf'],
        'application/sbml+xml': ['sbml'],
        'application/schema+json': ['json'],
        'application/scvp-cv-request': ['scq'],
        'application/scvp-cv-response': ['scs'],
        'application/scvp-vp-request': ['spq'],
        'application/scvp-vp-response': ['spp'],
        'application/sdp': ['sdp'],
        'application/senml+xml': ['senmlx'],
        'application/sensml+xml': ['sensmlx'],
        'application/set-payment-initiation': ['setpay'],
        'application/set-registration-initiation': ['setreg'],
        'application/shf+xml': ['shf'],
        'application/sieve': ['siv', 'sieve'],
        'application/smil': ['smil', 'smi', 'sml', 'kino'],
        'application/smil+xml': ['smi', 'smil', 'sml', 'kino'],
        'application/sparql-query': ['rq', 'qs'],
        'application/sparql-results+xml': ['srx'],
        'application/spdx+json': ['spdx.json'],
        'application/sql': ['sql'],
        'application/srgs': ['gram'],
        'application/srgs+xml': ['grxml'],
        'application/sru+xml': ['sru'],
        'application/ssdl+xml': ['ssdl'],
        'application/ssml+xml': ['ssml'],
        'application/stuffit': ['sit', 'hqx'],
        'application/swid+xml': ['swidtag'],
        'application/tei+xml': ['tei', 'teicorpus'],
        'application/tga': ['tga', 'icb', 'tpic', 'vda', 'vst'],
        'application/thraud+xml': ['tfi'],
        'application/timestamped-data': ['tsd'],
        'application/toml': ['toml'],
        'application/trig': ['trig'],
        'application/ttml+xml': ['ttml'],
        'application/typescript': ['cts', 'mts', 'ts'],
        'application/ubjson': ['ubj'],
        'application/urc-ressheet+xml': ['rsheet'],
        'application/urc-targetdesc+xml': ['td'],
        'application/vnd.1000minds.decision-model+xml': ['1km'],
        'application/vnd.3gpp.pic-bw-large': ['plb'],
        'application/vnd.3gpp.pic-bw-small': ['psb'],
        'application/vnd.3gpp.pic-bw-var': ['pvb'],
        'application/vnd.3gpp2.tcap': ['tcap'],
        'application/vnd.3m.post-it-notes': ['pwn'],
        'application/vnd.accpac.simply.aso': ['aso'],
        'application/vnd.accpac.simply.imp': ['imp'],
        'application/vnd.acucobol': ['acu'],
        'application/vnd.acucorp': ['atc', 'acutc'],
        'application/vnd.adobe.air-application-installer-package+zip': ['air'],
        'application/vnd.adobe.flash.movie': ['swf', 'spl'],
        'application/vnd.adobe.formscentral.fcdt': ['fcdt'],
        'application/vnd.adobe.fxp': ['fxp', 'fxpl'],
        'application/vnd.adobe.illustrator': ['ai'],
        'application/vnd.adobe.xdp+xml': ['xdp'],
        'application/vnd.adobe.xfdf': ['xfdf'],
        'application/vnd.age': ['age'],
        'application/vnd.ahead.space': ['ahead'],
        'application/vnd.airzip.filesecure.azf': ['azf'],
        'application/vnd.airzip.filesecure.azs': ['azs'],
        'application/vnd.amazon.ebook': ['azw'],
        'application/vnd.amazon.mobi8-ebook': ['azw3', 'kfx'],
        'application/vnd.americandynamics.acc': ['acc'],
        'application/vnd.amiga.ami': ['ami'],
        'application/vnd.android.package-archive': ['apk'],
        'application/vnd.anser-web-certificate-issue-initiation': ['cii'],
        'application/vnd.anser-web-funds-transfer-initiation': ['fti'],
        'application/vnd.antix.game-component': ['atx'],
        'application/vnd.apache.parquet': ['parquet'],
        'application/vnd.appimage': ['appimage'],
        'application/vnd.apple.installer+xml': ['mpkg'],
        'application/vnd.apple.keynote': ['key', 'keynote'],
        'application/vnd.apple.mpegurl': ['m3u8', 'm3u'],
        'application/vnd.apple.numbers': ['numbers'],
        'application/vnd.apple.pages': ['pages'],
        'application/vnd.apple.pkpass': ['pkpass'],
        'application/vnd.apple.pkpasses': ['pkpasses'],
        'application/vnd.aristanetworks.swi': ['swi'],
        'application/vnd.astraea-software.iota': ['iota'],
        'application/vnd.audiograph': ['aep'],
        'application/vnd.balsamiq.bmml+xml': ['bmml'],
        'application/vnd.blueice.multipass': ['mpm'],
        'application/vnd.bmi': ['bmi'],
        'application/vnd.businessobjects': ['rep'],
        'application/vnd.chemdraw+xml': ['cdxml'],
        'application/vnd.chess-pgn': ['pgn'],
        'application/vnd.chipnuts.karaoke-mmd': ['mmd'],
        'application/vnd.cinderella': ['cdy'],
        'application/vnd.citationstyles.style+xml': ['csl'],
        'application/vnd.claymore': ['cla'],
        'application/vnd.cloanto.rp9': ['rp9'],
        'application/vnd.clonk.c4group': ['c4g', 'c4d', 'c4f', 'c4p', 'c4u'],
        'application/vnd.cluetrust.cartomobile-config': ['c11amc'],
        'application/vnd.cluetrust.cartomobile-config-pkg': ['c11amz'],
        'application/vnd.coffeescript': ['coffee'],
        'application/vnd.comicbook+zip': ['cbz'],
        'application/vnd.comicbook-rar': ['cbr'],
        'application/vnd.commonspace': ['csp'],
        'application/vnd.contact.cmsg': ['cdbcmsg'],
        'application/vnd.corel-draw': ['cdr'],
        'application/vnd.cosmocaller': ['cmc'],
        'application/vnd.crick.clicker': ['clkx'],
        'application/vnd.crick.clicker.keyboard': ['clkk'],
        'application/vnd.crick.clicker.palette': ['clkp'],
        'application/vnd.crick.clicker.template': ['clkt'],
        'application/vnd.crick.clicker.wordbank': ['clkw'],
        'application/vnd.criticaltools.wbs+xml': ['wbs'],
        'application/vnd.ctc-posml': ['pml'],
        'application/vnd.cups-ppd': ['ppd'],
        'application/vnd.curl.car': ['car'],
        'application/vnd.curl.pcurl': ['pcurl'],
        'application/vnd.cyclonedx+json': ['cdx.json'],
        'application/vnd.cyclonedx+xml': ['cdx.xml'],
        'application/vnd.dart': ['dart'],
        'application/vnd.data-vision.rdz': ['rdz'],
        'application/vnd.dbf': ['dbf'],
        'application/vnd.debian.binary-package': ['deb', 'udeb'],
        'application/vnd.dece.data': ['uvf', 'uvvf', 'uvd', 'uvvd'],
        'application/vnd.dece.ttml+xml': ['uvt', 'uvvt'],
        'application/vnd.dece.unspecified': ['uvx', 'uvvx'],
        'application/vnd.dece.zip': ['uvz', 'uvvz'],
        'application/vnd.denovo.fcselayout-link': ['fe_launch'],
        'application/vnd.dna': ['dna'],
        'application/vnd.dolby.mlp': ['mlp'],
        'application/vnd.dpgraph': ['dpg'],
        'application/vnd.dreamfactory': ['dfac'],
        'application/vnd.ds-keypoint': ['kpxx'],
        'application/vnd.dvb.ait': ['ait'],
        'application/vnd.dvb.service': ['svc'],
        'application/vnd.dynageo': ['geo'],
        'application/vnd.ecowin.chart': ['mag'],
        'application/vnd.efi.img': ['raw-disk-image', 'img'],
        'application/vnd.efi.iso': ['iso', 'iso9660'],
        'application/vnd.emusic-emusic_package': ['emp'],
        'application/vnd.enliven': ['nml'],
        'application/vnd.epson.esf': ['esf'],
        'application/vnd.epson.msf': ['msf'],
        'application/vnd.epson.quickanime': ['qam'],
        'application/vnd.epson.salt': ['slt'],
        'application/vnd.epson.ssf': ['ssf'],
        'application/vnd.eszigno3+xml': ['es3', 'et3'],
        'application/vnd.etsi.asic-e+zip': ['asice'],
        'application/vnd.ezpix-album': ['ez2'],
        'application/vnd.ezpix-package': ['ez3'],
        'application/vnd.fdf': ['fdf'],
        'application/vnd.fdsn.mseed': ['mseed'],
        'application/vnd.fdsn.seed': ['seed', 'dataless'],
        'application/vnd.flatpak': ['flatpak', 'xdgapp'],
        'application/vnd.flatpak.ref': ['flatpakref'],
        'application/vnd.flatpak.repo': ['flatpakrepo'],
        'application/vnd.flographit': ['gph'],
        'application/vnd.fluxtime.clip': ['ftc'],
        'application/vnd.framemaker': ['fm', 'frame', 'maker', 'book'],
        'application/vnd.frogans.fnc': ['fnc'],
        'application/vnd.frogans.ltf': ['ltf'],
        'application/vnd.fsc.weblaunch': ['fsc'],
        'application/vnd.fujitsu.oasys': ['oas'],
        'application/vnd.fujitsu.oasys2': ['oa2'],
        'application/vnd.fujitsu.oasys3': ['oa3'],
        'application/vnd.fujitsu.oasysgp': ['fg5'],
        'application/vnd.fujitsu.oasysprs': ['bh2'],
        'application/vnd.fujixerox.ddd': ['ddd'],
        'application/vnd.fujixerox.docuworks': ['xdw'],
        'application/vnd.fujixerox.docuworks.binder': ['xbd'],
        'application/vnd.fuzzysheet': ['fzs'],
        'application/vnd.genomatix.tuxedo': ['txd'],
        'application/vnd.geo+json': ['geojson', 'geo.json'],
        'application/vnd.geogebra.file': ['ggb'],
        'application/vnd.geogebra.slides': ['ggs'],
        'application/vnd.geogebra.tool': ['ggt'],
        'application/vnd.geometry-explorer': ['gex', 'gre'],
        'application/vnd.geonext': ['gxt'],
        'application/vnd.geoplan': ['g2w'],
        'application/vnd.geospace': ['g3w'],
        'application/vnd.gerber': ['gbr'],
        'application/vnd.gmx': ['gmx'],
        'application/vnd.google-apps.document': ['gdoc'],
        'application/vnd.google-apps.presentation': ['gslides'],
        'application/vnd.google-apps.spreadsheet': ['gsheet'],
        'application/vnd.google-earth.kml+xml': ['kml'],
        'application/vnd.google-earth.kmz': ['kmz'],
        'application/vnd.gov.sk.xmldatacontainer+xml': ['xdcf'],
        'application/vnd.grafeq': ['gqf', 'gqs'],
        'application/vnd.groove-account': ['gac'],
        'application/vnd.groove-help': ['ghf'],
        'application/vnd.groove-identity-message': ['gim'],
        'application/vnd.groove-injector': ['grv'],
        'application/vnd.groove-tool-message': ['gtm'],
        'application/vnd.groove-tool-template': ['tpl'],
        'application/vnd.groove-vcard': ['vcg'],
        'application/vnd.haansoft-hwp': ['hwp'],
        'application/vnd.haansoft-hwt': ['hwt'],
        'application/vnd.hal+xml': ['hal'],
        'application/vnd.handheld-entertainment+xml': ['zmm'],
        'application/vnd.hbci': ['hbci'],
        'application/vnd.hhe.lesson-player': ['les'],
        'application/vnd.hp-hpgl': ['hpgl'],
        'application/vnd.hp-hpid': ['hpid'],
        'application/vnd.hp-hps': ['hps'],
        'application/vnd.hp-jlyt': ['jlt'],
        'application/vnd.hp-pcl': ['pcl'],
        'application/vnd.hp-pclxl': ['pclxl'],
        'application/vnd.hydrostatix.sof-data': ['sfd-hdstx'],
        'application/vnd.ibm.minipay': ['mpy'],
        'application/vnd.ibm.modcap': ['afp', 'listafp', 'list3820'],
        'application/vnd.ibm.rights-management': ['irm'],
        'application/vnd.ibm.secure-container': ['sc'],
        'application/vnd.iccprofile': ['icc', 'icm'],
        'application/vnd.igloader': ['igl'],
        'application/vnd.immervision-ivp': ['ivp'],
        'application/vnd.immervision-ivu': ['ivu'],
        'application/vnd.insors.igm': ['igm'],
        'application/vnd.intercon.formnet': ['xpw', 'xpx'],
        'application/vnd.intergeo': ['i2g'],
        'application/vnd.intu.qbo': ['qbo'],
        'application/vnd.intu.qfx': ['qfx'],
        'application/vnd.ipunplugged.rcprofile': ['rcprofile'],
        'application/vnd.irepository.package+xml': ['irp'],
        'application/vnd.is-xpr': ['xpr'],
        'application/vnd.isac.fcs': ['fcs'],
        'application/vnd.jam': ['jam'],
        'application/vnd.jcp.javame.midlet-rms': ['rms'],
        'application/vnd.jisp': ['jisp'],
        'application/vnd.joost.joda-archive': ['joda'],
        'application/vnd.kahootz': ['ktz', 'ktr'],
        'application/vnd.kde.karbon': ['karbon'],
        'application/vnd.kde.kchart': ['chrt'],
        'application/vnd.kde.kformula': ['kfo'],
        'application/vnd.kde.kivio': ['flw'],
        'application/vnd.kde.kontour': ['kon'],
        'application/vnd.kde.kpresenter': ['kpr', 'kpt'],
        'application/vnd.kde.kspread': ['ksp'],
        'application/vnd.kde.kword': ['kwd', 'kwt'],
        'application/vnd.kenameaapp': ['htke'],
        'application/vnd.kidspiration': ['kia'],
        'application/vnd.kinar': ['kne', 'knp'],
        'application/vnd.koan': ['skp', 'skd', 'skt', 'skm'],
        'application/vnd.kodak-descriptor': ['sse'],
        'application/vnd.las.las+xml': ['lasxml'],
        'application/vnd.llamagraphics.life-balance.desktop': ['lbd'],
        'application/vnd.llamagraphics.life-balance.exchange+xml': ['lbe'],
        'application/vnd.lotus-1-2-3': ['123', 'wk1', 'wk3', 'wk4', 'wks'],
        'application/vnd.lotus-approach': ['apr'],
        'application/vnd.lotus-freelance': ['pre'],
        'application/vnd.lotus-notes': ['nsf'],
        'application/vnd.lotus-organizer': ['org'],
        'application/vnd.lotus-screencam': ['scm'],
        'application/vnd.lotus-wordpro': ['lwp'],
        'application/vnd.macports.portpkg': ['portpkg'],
        'application/vnd.mapbox-vector-tile': ['mvt'],
        'application/vnd.mcd': ['mcd'],
        'application/vnd.medcalcdata': ['mc1'],
        'application/vnd.mediastation.cdkey': ['cdkey'],
        'application/vnd.mfer': ['mwf'],
        'application/vnd.mfmp': ['mfm'],
        'application/vnd.micrografx.flo': ['flo'],
        'application/vnd.micrografx.igx': ['igx'],
        'application/vnd.microsoft.portable-executable': [
            'exe',
            'dll',
            'cpl',
            'drv',
            'scr',
            'efi',
            'ocx',
            'sys',
            'lib',
        ],
        'application/vnd.mif': ['mif'],
        'application/vnd.mobius.daf': ['daf'],
        'application/vnd.mobius.dis': ['dis'],
        'application/vnd.mobius.mbk': ['mbk'],
        'application/vnd.mobius.mqy': ['mqy'],
        'application/vnd.mobius.msl': ['msl'],
        'application/vnd.mobius.plc': ['plc'],
        'application/vnd.mobius.txf': ['txf'],
        'application/vnd.mophun.application': ['mpn'],
        'application/vnd.mophun.certificate': ['mpc'],
        'application/vnd.mozilla.xul+xml': ['xul'],
        'application/vnd.ms-3mfdocument': ['3mf'],
        'application/vnd.ms-access': ['mdb'],
        'application/vnd.ms-artgalry': ['cil'],
        'application/vnd.ms-asf': ['asf'],
        'application/vnd.ms-cab-compressed': ['cab'],
        'application/vnd.ms-excel': [
            'xls',
            'xlm',
            'xla',
            'xlc',
            'xlt',
            'xlw',
            'xll',
            'xld',
        ],
        'application/vnd.ms-excel.addin.macroenabled.12': ['xlam'],
        'application/vnd.ms-excel.sheet.binary.macroenabled.12': ['xlsb'],
        'application/vnd.ms-excel.sheet.macroenabled.12': ['xlsm'],
        'application/vnd.ms-excel.template.macroenabled.12': ['xltm'],
        'application/vnd.ms-fontobject': ['eot'],
        'application/vnd.ms-htmlhelp': ['chm'],
        'application/vnd.ms-ims': ['ims'],
        'application/vnd.ms-lrm': ['lrm'],
        'application/vnd.ms-officetheme': ['thmx'],
        'application/vnd.ms-outlook': ['msg'],
        'application/vnd.ms-pki.seccat': ['cat'],
        'application/vnd.ms-pki.stl': ['stl'],
        'application/vnd.ms-powerpoint': ['ppt', 'pps', 'pot', 'ppz'],
        'application/vnd.ms-powerpoint.addin.macroenabled.12': ['ppam'],
        'application/vnd.ms-powerpoint.presentation.macroenabled.12': ['pptm'],
        'application/vnd.ms-powerpoint.slide.macroenabled.12': ['sldm'],
        'application/vnd.ms-powerpoint.slideshow.macroenabled.12': ['ppsm'],
        'application/vnd.ms-powerpoint.template.macroenabled.12': ['potm'],
        'application/vnd.ms-project': ['mpp', 'mpt'],
        'application/vnd.ms-publisher': ['pub'],
        'application/vnd.ms-tnef': ['tnef', 'tnf'],
        'application/vnd.ms-visio.drawing.macroenabled.main+xml': ['vsdm'],
        'application/vnd.ms-visio.drawing.main+xml': ['vsdx'],
        'application/vnd.ms-visio.stencil.macroenabled.main+xml': ['vssm'],
        'application/vnd.ms-visio.stencil.main+xml': ['vssx'],
        'application/vnd.ms-visio.template.macroenabled.main+xml': ['vstm'],
        'application/vnd.ms-visio.template.main+xml': ['vstx'],
        'application/vnd.ms-word': ['doc'],
        'application/vnd.ms-word.document.macroenabled.12': ['docm'],
        'application/vnd.ms-word.template.macroenabled.12': ['dotm'],
        'application/vnd.ms-works': ['wps', 'wks', 'wcm', 'wdb', 'xlr'],
        'application/vnd.ms-wpl': ['wpl'],
        'application/vnd.ms-xpsdocument': ['xps'],
        'application/vnd.msaccess': ['mdb'],
        'application/vnd.mseq': ['mseq'],
        'application/vnd.musician': ['mus'],
        'application/vnd.muvee.style': ['msty'],
        'application/vnd.mynfc': ['taglet'],
        'application/vnd.nato.bindingdataobject+xml': ['bdo'],
        'application/vnd.neurolanguage.nlu': ['nlu'],
        'application/vnd.nintendo.nitro.rom': ['nds'],
        'application/vnd.nintendo.snes.rom': ['sfc', 'smc'],
        'application/vnd.nitf': ['ntf', 'nitf'],
        'application/vnd.noblenet-directory': ['nnd'],
        'application/vnd.noblenet-sealer': ['nns'],
        'application/vnd.noblenet-web': ['nnw'],
        'application/vnd.nokia.n-gage.ac+xml': ['ac'],
        'application/vnd.nokia.n-gage.data': ['ngdat'],
        'application/vnd.nokia.n-gage.symbian.install': ['n-gage'],
        'application/vnd.nokia.radio-preset': ['rpst'],
        'application/vnd.nokia.radio-presets': ['rpss'],
        'application/vnd.novadigm.edm': ['edm'],
        'application/vnd.novadigm.edx': ['edx'],
        'application/vnd.novadigm.ext': ['ext'],
        'application/vnd.oasis.docbook+xml': ['dbk', 'docbook'],
        'application/vnd.oasis.opendocument.base': ['odb'],
        'application/vnd.oasis.opendocument.chart': ['odc'],
        'application/vnd.oasis.opendocument.chart-template': ['otc'],
        'application/vnd.oasis.opendocument.database': ['odb'],
        'application/vnd.oasis.opendocument.formula': ['odf'],
        'application/vnd.oasis.opendocument.formula-template': ['odft', 'otf'],
        'application/vnd.oasis.opendocument.graphics': ['odg'],
        'application/vnd.oasis.opendocument.graphics-flat-xml': ['fodg'],
        'application/vnd.oasis.opendocument.graphics-template': ['otg'],
        'application/vnd.oasis.opendocument.image': ['odi'],
        'application/vnd.oasis.opendocument.image-template': ['oti'],
        'application/vnd.oasis.opendocument.presentation': ['odp'],
        'application/vnd.oasis.opendocument.presentation-flat-xml': ['fodp'],
        'application/vnd.oasis.opendocument.presentation-template': ['otp'],
        'application/vnd.oasis.opendocument.spreadsheet': ['ods'],
        'application/vnd.oasis.opendocument.spreadsheet-flat-xml': ['fods'],
        'application/vnd.oasis.opendocument.spreadsheet-template': ['ots'],
        'application/vnd.oasis.opendocument.text': ['odt'],
        'application/vnd.oasis.opendocument.text-flat-xml': ['fodt'],
        'application/vnd.oasis.opendocument.text-master': ['odm'],
        'application/vnd.oasis.opendocument.text-master-template': ['otm'],
        'application/vnd.oasis.opendocument.text-template': ['ott'],
        'application/vnd.oasis.opendocument.text-web': ['oth'],
        'application/vnd.olpc-sugar': ['xo'],
        'application/vnd.oma.dd2+xml': ['dd2'],
        'application/vnd.openblox.game+xml': ['obgx'],
        'application/vnd.openofficeorg.extension': ['oxt'],
        'application/vnd.openstreetmap.data+xml': ['osm'],
        'application/vnd.openxmlformats-officedocument.presentationml.presentation':
            ['pptx'],
        'application/vnd.openxmlformats-officedocument.presentationml.slide': [
            'sldx',
        ],
        'application/vnd.openxmlformats-officedocument.presentationml.slideshow':
            ['ppsx'],
        'application/vnd.openxmlformats-officedocument.presentationml.template':
            ['potx'],
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
            'xlsx',
        ],
        'application/vnd.openxmlformats-officedocument.spreadsheetml.template':
            ['xltx'],
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            ['docx'],
        'application/vnd.openxmlformats-officedocument.wordprocessingml.template':
            ['dotx'],
        'application/vnd.osgeo.mapguide.package': ['mgp'],
        'application/vnd.osgi.dp': ['dp'],
        'application/vnd.osgi.subsystem': ['esa'],
        'application/vnd.palm': ['pdb', 'pqa', 'oprc', 'prc'],
        'application/vnd.pawaafile': ['paw'],
        'application/vnd.pg.format': ['str'],
        'application/vnd.pg.osasli': ['ei6'],
        'application/vnd.picsel': ['efif'],
        'application/vnd.pmi.widget': ['wg'],
        'application/vnd.pocketlearn': ['plf'],
        'application/vnd.powerbuilder6': ['pbd'],
        'application/vnd.previewsystems.box': ['box'],
        'application/vnd.proteus.magazine': ['mgz'],
        'application/vnd.publishare-delta-tree': ['qps'],
        'application/vnd.pvi.ptid1': ['ptid'],
        'application/vnd.pwg-xhtml-print+xml': ['xhtm'],
        'application/vnd.quark.quarkxpress': [
            'qxd',
            'qxt',
            'qwd',
            'qwt',
            'qxl',
            'qxb',
            'qxp',
        ],
        'application/vnd.rar': ['rar'],
        'application/vnd.realvnc.bed': ['bed'],
        'application/vnd.recordare.musicxml': ['mxl'],
        'application/vnd.recordare.musicxml+xml': ['musicxml'],
        'application/vnd.rig.cryptonote': ['cryptonote'],
        'application/vnd.rim.cod': ['cod'],
        'application/vnd.rn-realmedia': [
            'rm',
            'rmj',
            'rmm',
            'rms',
            'rmx',
            'rmvb',
        ],
        'application/vnd.rn-realmedia-vbr': [
            'rmvb',
            'rm',
            'rmj',
            'rmm',
            'rms',
            'rmx',
        ],
        'application/vnd.route66.link66+xml': ['link66'],
        'application/vnd.sailingtracker.track': ['st'],
        'application/vnd.sdp': ['sdp'],
        'application/vnd.seemail': ['see'],
        'application/vnd.sema': ['sema'],
        'application/vnd.semd': ['semd'],
        'application/vnd.semf': ['semf'],
        'application/vnd.shana.informed.formdata': ['ifm'],
        'application/vnd.shana.informed.formtemplate': ['itp'],
        'application/vnd.shana.informed.interchange': ['iif'],
        'application/vnd.shana.informed.package': ['ipk'],
        'application/vnd.simtech-mindmapper': ['twd', 'twds'],
        'application/vnd.smaf': ['mmf', 'smaf'],
        'application/vnd.smart.teacher': ['teacher'],
        'application/vnd.snap': ['snap'],
        'application/vnd.software602.filler.form+xml': ['fo'],
        'application/vnd.solent.sdkm+xml': ['sdkm', 'sdkd'],
        'application/vnd.spotfire.dxp': ['dxp'],
        'application/vnd.spotfire.sfs': ['sfs'],
        'application/vnd.sqlite3': ['sqlite3'],
        'application/vnd.squashfs': ['sfs', 'sqfs', 'sqsh', 'squashfs'],
        'application/vnd.stardivision.calc': ['sdc'],
        'application/vnd.stardivision.chart': ['sds'],
        'application/vnd.stardivision.draw': ['sda'],
        'application/vnd.stardivision.impress': ['sdd'],
        'application/vnd.stardivision.impress-packed': ['sdp'],
        'application/vnd.stardivision.mail': ['sdm'],
        'application/vnd.stardivision.math': ['smf'],
        'application/vnd.stardivision.writer': ['sdw', 'vor'],
        'application/vnd.stardivision.writer-global': ['sgl'],
        'application/vnd.stepmania.package': ['smzip'],
        'application/vnd.stepmania.stepchart': ['sm'],
        'application/vnd.sun.wadl+xml': ['wadl'],
        'application/vnd.sun.xml.base': ['odb'],
        'application/vnd.sun.xml.calc': ['sxc'],
        'application/vnd.sun.xml.calc.template': ['stc'],
        'application/vnd.sun.xml.draw': ['sxd'],
        'application/vnd.sun.xml.draw.template': ['std'],
        'application/vnd.sun.xml.impress': ['sxi'],
        'application/vnd.sun.xml.impress.template': ['sti'],
        'application/vnd.sun.xml.math': ['sxm'],
        'application/vnd.sun.xml.writer': ['sxw'],
        'application/vnd.sun.xml.writer.global': ['sxg'],
        'application/vnd.sun.xml.writer.template': ['stw'],
        'application/vnd.sus-calendar': ['sus', 'susp'],
        'application/vnd.svd': ['svd'],
        'application/vnd.symbian.install': ['sis', 'sisx'],
        'application/vnd.syncml+xml': ['xsm'],
        'application/vnd.syncml.dm+wbxml': ['bdm'],
        'application/vnd.syncml.dm+xml': ['xdm'],
        'application/vnd.syncml.dmddf+xml': ['ddf'],
        'application/vnd.tao.intent-module-archive': ['tao'],
        'application/vnd.tcpdump.pcap': ['pcap', 'cap', 'dmp'],
        'application/vnd.tmobile-livetv': ['tmo'],
        'application/vnd.trid.tpt': ['tpt'],
        'application/vnd.triscape.mxs': ['mxs'],
        'application/vnd.trueapp': ['tra'],
        'application/vnd.truedoc': ['pfr'],
        'application/vnd.ufdl': ['ufd', 'ufdl'],
        'application/vnd.uiq.theme': ['utz'],
        'application/vnd.umajin': ['umj'],
        'application/vnd.unity': ['unityweb'],
        'application/vnd.uoml+xml': ['uoml', 'uo'],
        'application/vnd.vcx': ['vcx'],
        'application/vnd.visio': ['vsd', 'vst', 'vss', 'vsw'],
        'application/vnd.visionary': ['vis'],
        'application/vnd.vsf': ['vsf'],
        'application/vnd.wap.wbxml': ['wbxml'],
        'application/vnd.wap.wmlc': ['wmlc'],
        'application/vnd.wap.wmlscriptc': ['wmlsc'],
        'application/vnd.webturbo': ['wtb'],
        'application/vnd.wolfram.player': ['nbp'],
        'application/vnd.wordperfect': [
            'wpd',
            'wp',
            'wp4',
            'wp5',
            'wp6',
            'wpp',
        ],
        'application/vnd.wqd': ['wqd'],
        'application/vnd.wt.stf': ['stf'],
        'application/vnd.xara': ['xar'],
        'application/vnd.xdgapp': ['flatpak', 'xdgapp'],
        'application/vnd.xfdl': ['xfdl'],
        'application/vnd.yamaha.hv-dic': ['hvd'],
        'application/vnd.yamaha.hv-script': ['hvs'],
        'application/vnd.yamaha.hv-voice': ['hvp'],
        'application/vnd.yamaha.openscoreformat': ['osf'],
        'application/vnd.yamaha.openscoreformat.osfpvg+xml': ['osfpvg'],
        'application/vnd.yamaha.smaf-audio': ['saf'],
        'application/vnd.yamaha.smaf-phrase': ['spf'],
        'application/vnd.yellowriver-custom-menu': ['cmp'],
        'application/vnd.youtube.yt': ['yt'],
        'application/vnd.zul': ['zir', 'zirz'],
        'application/vnd.zzazz.deck+xml': ['zaz'],
        'application/voicexml+xml': ['vxml'],
        'application/wasm': ['wasm'],
        'application/watcherinfo+xml': ['wif'],
        'application/widget': ['wgt'],
        'application/winhlp': ['hlp'],
        'application/wk1': ['123', 'wk1', 'wk3', 'wk4', 'wks'],
        'application/wmf': ['wmf'],
        'application/wordperfect': ['wp', 'wp4', 'wp5', 'wp6', 'wpd', 'wpp'],
        'application/wsdl+xml': ['wsdl'],
        'application/wspolicy+xml': ['wspolicy'],
        'application/wwf': ['wwf'],
        'application/x-123': ['123', 'wk1', 'wk3', 'wk4', 'wks'],
        'application/x-7z-compressed': ['7z', '7z.001'],
        'application/x-abiword': ['abw', 'abw.CRASHED', 'abw.gz', 'zabw'],
        'application/x-ace': ['ace'],
        'application/x-ace-compressed': ['ace'],
        'application/x-adobe-aftereffects-project': ['aep'],
        'application/x-adobe-aftereffects-template': ['aet'],
        'application/x-adobe-incopy-interchange': ['incx'],
        'application/x-adobe-indesign': ['indd'],
        'application/x-adobe-indesign-interchange': ['inx'],
        'application/x-adobe-premiere-project': ['prproj'],
        'application/x-adobe-premiere-title': ['prtl'],
        'application/x-alpine-package-keeper-package': ['apk'],
        'application/x-alz': ['alz'],
        'application/x-amf': ['amf'],
        'application/x-amiga-disk-format': ['adf'],
        'application/x-amipro': ['sam'],
        'application/x-annodex': ['anx'],
        'application/x-aportisdoc': ['pdb', 'pdc'],
        'application/x-apple-diskimage': ['dmg'],
        'application/x-apple-systemprofiler+xml': ['spx'],
        'application/x-appleworks-document': ['cwk'],
        'application/x-applix-spreadsheet': ['as'],
        'application/x-applix-word': ['aw'],
        'application/x-archive': ['a', 'ar', 'lib'],
        'application/x-arj': ['arj'],
        'application/x-asar': ['asar'],
        'application/x-asp': ['asp'],
        'application/x-atari-2600-rom': ['a26'],
        'application/x-atari-7800-rom': ['a78'],
        'application/x-atari-lynx-rom': ['lnx'],
        'application/x-authorware-bin': ['aab', 'x32', 'u32', 'vox'],
        'application/x-authorware-map': ['aam'],
        'application/x-authorware-seg': ['aas'],
        'application/x-awk': ['awk'],
        'application/x-bat': ['bat'],
        'application/x-bcpio': ['bcpio'],
        'application/x-bdoc': ['bdoc'],
        'application/x-bittorrent': ['torrent'],
        'application/x-blender': ['blend', 'blender'],
        'application/x-blorb': ['blb', 'blorb'],
        'application/x-bps-patch': ['bps'],
        'application/x-bsdiff': ['bsdiff'],
        'application/x-bz2': ['bz2'],
        'application/x-bzdvi': ['dvi.bz2'],
        'application/x-bzip': ['bz', 'bz2'],
        'application/x-bzip-compressed-tar': ['tar.bz2', 'tbz2', 'tb2'],
        'application/x-bzip1': ['bz'],
        'application/x-bzip1-compressed-tar': ['tar.bz', 'tbz'],
        'application/x-bzip2': ['bz2', 'boz'],
        'application/x-bzip2-compressed-tar': ['tar.bz2', 'tbz2', 'tb2'],
        'application/x-bzip3': ['bz3'],
        'application/x-bzip3-compressed-tar': ['tar.bz3', 'tbz3'],
        'application/x-bzpdf': ['pdf.bz2'],
        'application/x-bzpostscript': ['ps.bz2'],
        'application/x-cb7': ['cb7'],
        'application/x-cbr': ['cbr', 'cba', 'cbt', 'cbz', 'cb7'],
        'application/x-cbt': ['cbt'],
        'application/x-cbz': ['cbz'],
        'application/x-ccmx': ['ccmx'],
        'application/x-cd-image': ['iso', 'iso9660'],
        'application/x-cdlink': ['vcd'],
        'application/x-cdr': ['cdr'],
        'application/x-cdrdao-toc': ['toc'],
        'application/x-cfs-compressed': ['cfs'],
        'application/x-chat': ['chat'],
        'application/x-chess-pgn': ['pgn'],
        'application/x-chm': ['chm'],
        'application/x-chrome-extension': ['crx'],
        'application/x-cisco-vpn-settings': ['pcf'],
        'application/x-cocoa': ['cco'],
        'application/x-compress': ['Z'],
        'application/x-compressed-iso': ['cso'],
        'application/x-compressed-tar': ['tar.gz', 'tgz'],
        'application/x-conference': ['nsc'],
        'application/x-coreldraw': ['cdr'],
        'application/x-cpio': ['cpio'],
        'application/x-cpio-compressed': ['cpio.gz'],
        'application/x-csh': ['csh'],
        'application/x-cue': ['cue'],
        'application/x-dar': ['dar'],
        'application/x-dbase': ['dbf'],
        'application/x-dbf': ['dbf'],
        'application/x-dc-rom': ['dc'],
        'application/x-deb': ['deb', 'udeb'],
        'application/x-debian-package': ['deb', 'udeb'],
        'application/x-designer': ['ui'],
        'application/x-desktop': ['desktop', 'kdelnk'],
        'application/x-dgc-compressed': ['dgc'],
        'application/x-dia-diagram': ['dia'],
        'application/x-dia-shape': ['shape'],
        'application/x-director': [
            'dir',
            'dcr',
            'dxr',
            'cst',
            'cct',
            'cxt',
            'w3d',
            'fgd',
            'swa',
        ],
        'application/x-discjuggler-cd-image': ['cdi'],
        'application/x-docbook+xml': ['dbk', 'docbook'],
        'application/x-doom': ['wad'],
        'application/x-doom-wad': ['wad'],
        'application/x-dosexec': ['exe'],
        'application/x-dreamcast-rom': ['iso'],
        'application/x-dtbncx+xml': ['ncx'],
        'application/x-dtbook+xml': ['dtb'],
        'application/x-dtbresource+xml': ['res'],
        'application/x-dvi': ['dvi'],
        'application/x-e-theme': ['etheme'],
        'application/x-egon': ['egon'],
        'application/x-emf': ['emf'],
        'application/x-envoy': ['evy'],
        'application/x-eris-link+cbor': ['eris'],
        'application/x-eva': ['eva'],
        'application/x-excellon': ['drl'],
        'application/x-fd-file': ['fd', 'qd'],
        'application/x-fds-disk': ['fds'],
        'application/x-fictionbook': ['fb2'],
        'application/x-fictionbook+xml': ['fb2'],
        'application/x-fishscript': ['fish'],
        'application/x-flash-video': ['flv'],
        'application/x-fluid': ['fl'],
        'application/x-font-afm': ['afm'],
        'application/x-font-bdf': ['bdf'],
        'application/x-font-ghostscript': ['gsf'],
        'application/x-font-linux-psf': ['psf'],
        'application/x-font-otf': ['otf'],
        'application/x-font-pcf': ['pcf', 'pcf.Z', 'pcf.gz'],
        'application/x-font-snf': ['snf'],
        'application/x-font-speedo': ['spd'],
        'application/x-font-truetype': ['ttf'],
        'application/x-font-ttf': ['ttf'],
        'application/x-font-ttx': ['ttx'],
        'application/x-font-type1': ['pfa', 'pfb', 'pfm', 'afm', 'gsf'],
        'application/x-font-woff': ['woff'],
        'application/x-frame': ['fm'],
        'application/x-freearc': ['arc'],
        'application/x-freedesktop-appstream-component': [
            'metainfo.xml',
            'appdata.xml',
        ],
        'application/x-freedesktop-appstream-releases': ['releases.xml'],
        'application/x-futuresplash': ['spl'],
        'application/x-gameboy-color-rom': ['gbc', 'cgb'],
        'application/x-gameboy-rom': ['gb', 'sgb'],
        'application/x-gamecube-iso-image': ['iso'],
        'application/x-gamecube-rom': ['iso'],
        'application/x-gamegear-rom': ['gg'],
        'application/x-gba-rom': ['gba', 'agb'],
        'application/x-gca-compressed': ['gca'],
        'application/x-gd-rom-cue': ['gdi'],
        'application/x-gdscript': ['gd'],
        'application/x-gedcom': ['ged', 'gedcom'],
        'application/x-genesis-32x-rom': ['32x', 'mdx'],
        'application/x-genesis-rom': ['gen', 'smd', 'md', 'sgd'],
        'application/x-gerber': ['gbr'],
        'application/x-gerber-job': ['gbrjob'],
        'application/x-gettext': ['po'],
        'application/x-gettext-translation': ['gmo', 'mo'],
        'application/x-glade': ['glade'],
        'application/x-glulx': ['ulx'],
        'application/x-gnome-app-info': ['desktop', 'kdelnk'],
        'application/x-gnucash': ['gnucash', 'gnc', 'xac'],
        'application/x-gnumeric': ['gnumeric'],
        'application/x-gnuplot': ['gp', 'gplt', 'gnuplot'],
        'application/x-go-sgf': ['sgf'],
        'application/x-godot-resource': ['res', 'tres'],
        'application/x-godot-scene': ['scn', 'tscn', 'escn'],
        'application/x-godot-shader': ['gdshader'],
        'application/x-gpx': ['gpx'],
        'application/x-gpx+xml': ['gpx'],
        'application/x-gramps-xml': ['gramps'],
        'application/x-graphite': ['gra'],
        'application/x-gtar': ['gtar', 'tar', 'gem'],
        'application/x-gtk-builder': ['ui'],
        'application/x-gz-font-linux-psf': ['psf.gz'],
        'application/x-gzdvi': ['dvi.gz'],
        'application/x-gzip': ['gz'],
        'application/x-gzpdf': ['pdf.gz'],
        'application/x-gzpostscript': ['ps.gz'],
        'application/x-hdf': ['hdf', 'hdf4', 'h4', 'hdf5', 'h5'],
        'application/x-hfe-file': ['hfe'],
        'application/x-hfe-floppy-image': ['hfe'],
        'application/x-httpd-php': ['php'],
        'application/x-hwp': ['hwp'],
        'application/x-hwt': ['hwt'],
        'application/x-ica': ['ica'],
        'application/x-install-instructions': ['install'],
        'application/x-ips-patch': ['ips'],
        'application/x-ipynb+json': ['ipynb'],
        'application/x-iso9660-appimage': ['appimage'],
        'application/x-iso9660-image': ['iso', 'iso9660'],
        'application/x-it87': ['it87'],
        'application/x-iwork-keynote-sffkey': ['key'],
        'application/x-iwork-numbers-sffnumbers': ['numbers'],
        'application/x-iwork-pages-sffpages': ['pages'],
        'application/x-jar': ['jar'],
        'application/x-java': ['class'],
        'application/x-java-archive': ['jar'],
        'application/x-java-archive-diff': ['jardiff'],
        'application/x-java-class': ['class'],
        'application/x-java-jce-keystore': ['jceks'],
        'application/x-java-jnlp-file': ['jnlp'],
        'application/x-java-keystore': ['jks', 'ks'],
        'application/x-java-pack200': ['pack'],
        'application/x-java-vm': ['class'],
        'application/x-javascript': ['js', 'cjs', 'jsm', 'mjs'],
        'application/x-jbuilder-project': ['jpr', 'jpx'],
        'application/x-karbon': ['karbon'],
        'application/x-kchart': ['chrt'],
        'application/x-keepass2': ['kdbx'],
        'application/x-kexi-connectiondata': ['kexic'],
        'application/x-kexiproject-shortcut': ['kexis'],
        'application/x-kexiproject-sqlite': ['kexi'],
        'application/x-kexiproject-sqlite2': ['kexi'],
        'application/x-kexiproject-sqlite3': ['kexi'],
        'application/x-kformula': ['kfo'],
        'application/x-killustrator': ['kil'],
        'application/x-kivio': ['flw'],
        'application/x-kontour': ['kon'],
        'application/x-kpovmodeler': ['kpm'],
        'application/x-kpresenter': ['kpr', 'kpt'],
        'application/x-krita': ['kra', 'krz'],
        'application/x-kspread': ['ksp'],
        'application/x-kugar': ['kud'],
        'application/x-kword': ['kwd', 'kwt'],
        'application/x-latex': ['latex'],
        'application/x-lha': ['lha', 'lzh'],
        'application/x-lhz': ['lhz'],
        'application/x-linguist': ['ts'],
        'application/x-lmdb': ['mdb', 'lmdb'],
        'application/x-lotus123': ['123', 'wk1', 'wk3', 'wk4', 'wks'],
        'application/x-lrzip': ['lrz'],
        'application/x-lrzip-compressed-tar': ['tar.lrz', 'tlrz'],
        'application/x-lua-bytecode': ['luac'],
        'application/x-lyx': ['lyx'],
        'application/x-lz4': ['lz4'],
        'application/x-lz4-compressed-tar': ['tar.lz4'],
        'application/x-lzh-compressed': ['lzh', 'lha'],
        'application/x-lzip': ['lz'],
        'application/x-lzip-compressed-tar': ['tar.lz'],
        'application/x-lzma': ['lzma'],
        'application/x-lzma-compressed-tar': ['tar.lzma', 'tlz'],
        'application/x-lzop': ['lzo'],
        'application/x-lzpdf': ['pdf.lz'],
        'application/x-m4': ['m4'],
        'application/x-magicpoint': ['mgp'],
        'application/x-makeself': ['run'],
        'application/x-mame-chd': ['chd'],
        'application/x-markaby': ['mab'],
        'application/x-mathematica': ['nb'],
        'application/x-mdb': ['mdb'],
        'application/x-mie': ['mie'],
        'application/x-mif': ['mif'],
        'application/x-mimearchive': ['mhtml', 'mht'],
        'application/x-mobi8-ebook': ['azw3', 'kfx'],
        'application/x-mobipocket-ebook': ['prc', 'mobi'],
        'application/x-modrinth-modpack+zip': ['mrpack'],
        'application/x-ms-application': ['application'],
        'application/x-ms-asx': ['asx', 'wax', 'wvx', 'wmx'],
        'application/x-ms-dos-executable': ['exe', 'dll', 'cpl', 'drv', 'scr'],
        'application/x-ms-ne-executable': ['exe', 'dll', 'cpl', 'drv', 'scr'],
        'application/x-ms-pdb': ['pdb'],
        'application/x-ms-shortcut': ['lnk'],
        'application/x-ms-wim': ['wim', 'swm'],
        'application/x-ms-wmd': ['wmd'],
        'application/x-ms-wmz': ['wmz'],
        'application/x-ms-xbap': ['xbap'],
        'application/x-msaccess': ['mdb'],
        'application/x-msbinder': ['obd'],
        'application/x-mscardfile': ['crd'],
        'application/x-msclip': ['clp'],
        'application/x-msdos-program': ['exe'],
        'application/x-msdownload': [
            'exe',
            'dll',
            'com',
            'bat',
            'msi',
            'cpl',
            'drv',
            'scr',
        ],
        'application/x-msexcel': [
            'xls',
            'xlc',
            'xll',
            'xlm',
            'xlw',
            'xla',
            'xlt',
            'xld',
        ],
        'application/x-msi': ['msi'],
        'application/x-msmediaview': ['mvb', 'm13', 'm14'],
        'application/x-msmetafile': ['wmf', 'wmz', 'emf', 'emz'],
        'application/x-msmoney': ['mny'],
        'application/x-mspowerpoint': ['ppz', 'ppt', 'pps', 'pot'],
        'application/x-mspublisher': ['pub'],
        'application/x-msschedule': ['scd'],
        'application/x-msterminal': ['trm'],
        'application/x-mswinurl': ['url'],
        'application/x-msword': ['doc'],
        'application/x-mswrite': ['wri'],
        'application/x-msx-rom': ['msx'],
        'application/x-n64-rom': ['n64', 'z64', 'v64'],
        'application/x-navi-animation': ['ani'],
        'application/x-neo-geo-pocket-color-rom': ['ngc'],
        'application/x-neo-geo-pocket-rom': ['ngp'],
        'application/x-nes-rom': ['nes', 'nez', 'unf', 'unif'],
        'application/x-netcdf': ['nc', 'cdf'],
        'application/x-netshow-channel': ['nsc'],
        'application/x-nintendo-3ds-executable': ['3dsx'],
        'application/x-nintendo-3ds-rom': ['3ds', 'cci'],
        'application/x-nintendo-ds-rom': ['nds'],
        'application/x-nintendo-switch-xci': ['xci'],
        'application/x-ns-proxy-autoconfig': ['pac'],
        'application/x-nuscript': ['nu'],
        'application/x-nx-xci': ['xci'],
        'application/x-nzb': ['nzb'],
        'application/x-object': ['o', 'mod'],
        'application/x-ogg': ['ogx'],
        'application/x-oleo': ['oleo'],
        'application/x-openvpn-profile': ['openvpn', 'ovpn'],
        'application/x-openzim': ['zim'],
        'application/x-pagemaker': ['p65', 'pm', 'pm6', 'pmd'],
        'application/x-pak': ['pak'],
        'application/x-palm-database': ['prc', 'pdb', 'pqa', 'oprc'],
        'application/x-par2': ['PAR2', 'par2'],
        'application/x-parquet': ['parquet'],
        'application/x-partial-download': ['wkdownload', 'crdownload', 'part'],
        'application/x-pc-engine-rom': ['pce'],
        'application/x-pcap': ['pcap', 'cap', 'dmp'],
        'application/x-pcapng': ['pcapng', 'scap', 'ntar'],
        'application/x-pdf': ['pdf'],
        'application/x-perl': ['pl', 'pm', 'PL', 'al', 'perl', 'pod', 't'],
        'application/x-photoshop': ['psd'],
        'application/x-php': ['php', 'php3', 'php4', 'php5', 'phps'],
        'application/x-pilot': ['prc', 'pdb'],
        'application/x-pkcs12': ['p12', 'pfx'],
        'application/x-pkcs7-certificates': ['p7b', 'spc'],
        'application/x-pkcs7-certreqresp': ['p7r'],
        'application/x-planperfect': ['pln'],
        'application/x-pocket-word': ['psw'],
        'application/x-powershell': ['ps1'],
        'application/x-pw': ['pw'],
        'application/x-pyspread-bz-spreadsheet': ['pys'],
        'application/x-pyspread-spreadsheet': ['pysu'],
        'application/x-python-bytecode': ['pyc', 'pyo'],
        'application/x-qbrew': ['qbrew'],
        'application/x-qed-disk': ['qed'],
        'application/x-qemu-disk': ['qcow2', 'qcow'],
        'application/x-qpress': ['qp'],
        'application/x-qtiplot': ['qti', 'qti.gz'],
        'application/x-quattropro': ['wb1', 'wb2', 'wb3', 'qpw'],
        'application/x-quicktime-media-link': ['qtl'],
        'application/x-quicktimeplayer': ['qtl'],
        'application/x-qw': ['qif'],
        'application/x-rar': ['rar'],
        'application/x-rar-compressed': ['rar'],
        'application/x-raw-disk-image': ['raw-disk-image', 'img'],
        'application/x-raw-disk-image-xz-compressed': [
            'raw-disk-image.xz',
            'img.xz',
        ],
        'application/x-raw-floppy-disk-image': ['fd', 'qd'],
        'application/x-redhat-package-manager': ['rpm'],
        'application/x-reject': ['rej'],
        'application/x-research-info-systems': ['ris'],
        'application/x-rnc': ['rnc'],
        'application/x-rpm': ['rpm'],
        'application/x-ruby': ['rb'],
        'application/x-rzip': ['rz'],
        'application/x-rzip-compressed-tar': ['tar.rz', 'trz'],
        'application/x-sami': ['smi', 'sami'],
        'application/x-sap-file': ['sap'],
        'application/x-saturn-rom': ['iso'],
        'application/x-sdp': ['sdp'],
        'application/x-sea': ['sea'],
        'application/x-sega-cd-rom': ['iso'],
        'application/x-sega-pico-rom': ['iso'],
        'application/x-sg1000-rom': ['sg'],
        'application/x-sh': ['sh'],
        'application/x-shar': ['shar'],
        'application/x-shared-library-la': ['la'],
        'application/x-sharedlib': ['so', 'so.[0-9]*'],
        'application/x-shellscript': ['sh'],
        'application/x-shockwave-flash': ['swf', 'spl'],
        'application/x-shorten': ['shn'],
        'application/x-siag': ['siag'],
        'application/x-silverlight-app': ['xap'],
        'application/x-sit': ['sit'],
        'application/x-sitx': ['sitx'],
        'application/x-smaf': ['mmf', 'smaf'],
        'application/x-sms-rom': ['sms'],
        'application/x-snes-rom': ['sfc', 'smc'],
        'application/x-sony-bbeb': ['lrf'],
        'application/x-source-rpm': ['src.rpm', 'spm'],
        'application/x-spss-por': ['por'],
        'application/x-spss-sav': ['sav', 'zsav'],
        'application/x-spss-savefile': ['sav', 'zsav'],
        'application/x-sql': ['sql'],
        'application/x-sqlite2': ['sqlite2'],
        'application/x-sqlite3': ['sqlite3'],
        'application/x-srt': ['srt'],
        'application/x-starcalc': ['sdc'],
        'application/x-starchart': ['sds'],
        'application/x-stardraw': ['sda'],
        'application/x-starimpress': ['sdd'],
        'application/x-starmail': ['smd'],
        'application/x-starmath': ['smf'],
        'application/x-starwriter': ['sdw', 'vor'],
        'application/x-starwriter-global': ['sgl'],
        'application/x-stuffit': ['sit'],
        'application/x-stuffitx': ['sitx'],
        'application/x-subrip': ['srt'],
        'application/x-sv4cpio': ['sv4cpio'],
        'application/x-sv4crc': ['sv4crc'],
        'application/x-sylk': ['sylk', 'slk'],
        'application/x-t3vm-image': ['t3'],
        'application/x-t602': ['602'],
        'application/x-tads': ['gam'],
        'application/x-tar': ['tar', 'gtar', 'gem'],
        'application/x-targa': ['tga', 'icb', 'tpic', 'vda', 'vst'],
        'application/x-tarz': ['tar.Z', 'taz'],
        'application/x-tcl': ['tcl', 'tk'],
        'application/x-tex': [
            'tex',
            'ltx',
            'sty',
            'cls',
            'dtx',
            'ins',
            'latex',
        ],
        'application/x-tex-gf': ['gf'],
        'application/x-tex-pk': ['pk'],
        'application/x-tex-tfm': ['tfm'],
        'application/x-texinfo': ['texinfo', 'texi'],
        'application/x-tga': ['tga', 'icb', 'tpic', 'vda', 'vst'],
        'application/x-tgif': ['obj'],
        'application/x-theme': ['theme'],
        'application/x-thomson-cartridge-memo7': ['m7'],
        'application/x-thomson-cassette': ['k7'],
        'application/x-thomson-sap-image': ['sap'],
        'application/x-tiled-tmx': ['tmx'],
        'application/x-tiled-tsx': ['tsx'],
        'application/x-trash': ['bak', 'old', 'sik'],
        'application/x-trig': ['trig'],
        'application/x-troff': ['tr', 'roff', 't'],
        'application/x-troff-man': ['man', '[1-9]'],
        'application/x-tzo': ['tar.lzo', 'tzo'],
        'application/x-ufraw': ['ufraw'],
        'application/x-ustar': ['ustar'],
        'application/x-vdi-disk': ['vdi'],
        'application/x-vhd-disk': ['vhd', 'vpc'],
        'application/x-vhdx-disk': ['vhdx'],
        'application/x-virtual-boy-rom': ['vb'],
        'application/x-virtualbox-hdd': ['hdd'],
        'application/x-virtualbox-ova': ['ova'],
        'application/x-virtualbox-ovf': ['ovf'],
        'application/x-virtualbox-vbox': ['vbox'],
        'application/x-virtualbox-vbox-extpack': ['vbox-extpack'],
        'application/x-virtualbox-vdi': ['vdi'],
        'application/x-virtualbox-vhd': ['vhd', 'vpc'],
        'application/x-virtualbox-vhdx': ['vhdx'],
        'application/x-virtualbox-vmdk': ['vmdk'],
        'application/x-vmdk-disk': ['vmdk'],
        'application/x-vnd.kde.kexi': ['kexi'],
        'application/x-wais-source': ['src'],
        'application/x-wbfs': ['iso'],
        'application/x-web-app-manifest+json': ['webapp'],
        'application/x-wia': ['iso'],
        'application/x-wii-iso-image': ['iso'],
        'application/x-wii-rom': ['iso'],
        'application/x-wii-wad': ['wad'],
        'application/x-win-lnk': ['lnk'],
        'application/x-windows-themepack': ['themepack'],
        'application/x-wmf': ['wmf'],
        'application/x-wonderswan-color-rom': ['wsc'],
        'application/x-wonderswan-rom': ['ws'],
        'application/x-wordperfect': ['wp', 'wp4', 'wp5', 'wp6', 'wpd', 'wpp'],
        'application/x-wpg': ['wpg'],
        'application/x-wwf': ['wwf'],
        'application/x-x509-ca-cert': ['der', 'crt', 'pem', 'cert'],
        'application/x-xar': ['xar', 'pkg'],
        'application/x-xbel': ['xbel'],
        'application/x-xfig': ['fig'],
        'application/x-xliff': ['xlf', 'xliff'],
        'application/x-xliff+xml': ['xlf'],
        'application/x-xpinstall': ['xpi'],
        'application/x-xspf+xml': ['xspf'],
        'application/x-xz': ['xz'],
        'application/x-xz-compressed-tar': ['tar.xz', 'txz'],
        'application/x-xzpdf': ['pdf.xz'],
        'application/x-yaml': ['yaml', 'yml'],
        'application/x-zip': ['zip', 'zipx'],
        'application/x-zip-compressed': ['zip', 'zipx'],
        'application/x-zip-compressed-fb2': ['fb2.zip'],
        'application/x-zmachine': [
            'z1',
            'z2',
            'z3',
            'z4',
            'z5',
            'z6',
            'z7',
            'z8',
        ],
        'application/x-zoo': ['zoo'],
        'application/x-zpaq': ['zpaq'],
        'application/x-zstd-compressed-tar': ['tar.zst', 'tzst'],
        'application/x.sf3-archive': ['ar.sf3', 'sf3'],
        'application/x.sf3-log': ['log.sf3', 'sf3'],
        'application/x.sf3-table': ['tab.sf3', 'sf3'],
        'application/x.sf3-text': ['txt.sf3', 'sf3'],
        'application/xaml+xml': ['xaml'],
        'application/xcap-att+xml': ['xav'],
        'application/xcap-caps+xml': ['xca'],
        'application/xcap-diff+xml': ['xdf'],
        'application/xcap-el+xml': ['xel'],
        'application/xcap-error+xml': ['xer'],
        'application/xcap-ns+xml': ['xns'],
        'application/xenc+xml': ['xenc'],
        'application/xfdf': ['xfdf'],
        'application/xhtml+xml': ['xhtml', 'xht', 'html', 'htm'],
        'application/xliff+xml': ['xlf', 'xliff'],
        'application/xml': ['xml', 'xsl', 'xsd', 'rng', 'xbl'],
        'application/xml-dtd': ['dtd'],
        'application/xml-external-parsed-entity': ['ent'],
        'application/xop+xml': ['xop'],
        'application/xproc+xml': ['xpl'],
        'application/xps': ['xps'],
        'application/xslt+xml': ['xsl', 'xslt'],
        'application/xspf+xml': ['xspf'],
        'application/xv+xml': ['mxml', 'xhvml', 'xvml', 'xvm'],
        'application/yaml': ['yml', 'yaml'],
        'application/yang': ['yang'],
        'application/yin+xml': ['yin'],
        'application/zip': ['zip', 'zipx'],
        'application/zlib': ['zz'],
        'application/zstd': ['zst'],
        'audio/3gpp': ['3gpp', '3gp', '3ga'],
        'audio/3gpp-encrypted': ['3gp', '3gpp', '3ga'],
        'audio/3gpp2': ['3g2', '3gp2', '3gpp2'],
        'audio/aac': ['adts', 'aac', 'ass'],
        'audio/ac3': ['ac3'],
        'audio/adpcm': ['adp'],
        'audio/amr': ['amr'],
        'audio/amr-encrypted': ['amr'],
        'audio/amr-wb': ['awb'],
        'audio/amr-wb-encrypted': ['awb'],
        'audio/annodex': ['axa'],
        'audio/basic': ['au', 'snd'],
        'audio/dff': ['dff'],
        'audio/dsd': ['dsf'],
        'audio/dsf': ['dsf'],
        'audio/flac': ['flac'],
        'audio/imelody': ['imy', 'ime'],
        'audio/m3u': ['m3u', 'm3u8', 'vlc'],
        'audio/m4a': ['m4a', 'f4a'],
        'audio/matroska': ['mka'],
        'audio/midi': ['mid', 'midi', 'kar', 'rmi'],
        'audio/mobile-xmf': ['mxmf'],
        'audio/mp2': ['mp2'],
        'audio/mp3': ['mp3', 'mpga'],
        'audio/mp4': ['m4a', 'mp4a', 'f4a'],
        'audio/mpeg': ['mp3', 'mpga', 'mp2', 'mp2a', 'm2a', 'm3a'],
        'audio/mpegurl': ['m3u', 'm3u8', 'vlc'],
        'audio/ogg': ['ogg', 'oga', 'spx', 'opus'],
        'audio/prs.sid': ['sid', 'psid'],
        'audio/s3m': ['s3m'],
        'audio/scpls': ['pls'],
        'audio/silk': ['sil'],
        'audio/tta': ['tta'],
        'audio/usac': ['loas', 'xhe'],
        'audio/vnd.audible': ['aa', 'aax'],
        'audio/vnd.audible.aax': ['aax'],
        'audio/vnd.audible.aaxc': ['aaxc'],
        'audio/vnd.dece.audio': ['uva', 'uvva'],
        'audio/vnd.digital-winds': ['eol'],
        'audio/vnd.dra': ['dra'],
        'audio/vnd.dts': ['dts'],
        'audio/vnd.dts.hd': ['dtshd'],
        'audio/vnd.lucent.voice': ['lvp'],
        'audio/vnd.m-realaudio': ['ra', 'rax'],
        'audio/vnd.ms-playready.media.pya': ['pya'],
        'audio/vnd.nokia.mobile-xmf': ['mxmf'],
        'audio/vnd.nuera.ecelp4800': ['ecelp4800'],
        'audio/vnd.nuera.ecelp7470': ['ecelp7470'],
        'audio/vnd.nuera.ecelp9600': ['ecelp9600'],
        'audio/vnd.rip': ['rip'],
        'audio/vnd.rn-realaudio': ['ra', 'rax'],
        'audio/vnd.wave': ['wav'],
        'audio/vorbis': ['oga', 'ogg'],
        'audio/wav': ['wav'],
        'audio/wave': ['wav'],
        'audio/webm': ['weba'],
        'audio/wma': ['wma'],
        'audio/x-669': ['669', 'uni'],
        'audio/x-669-mod': ['669', 'uni'],
        'audio/x-aac': ['aac', 'adts', 'ass'],
        'audio/x-aifc': ['aifc', 'aiffc'],
        'audio/x-aiff': ['aif', 'aiff', 'aifc'],
        'audio/x-aiffc': ['aifc', 'aiffc'],
        'audio/x-amzxml': ['amz'],
        'audio/x-annodex': ['axa'],
        'audio/x-ape': ['ape'],
        'audio/x-caf': ['caf'],
        'audio/x-dff': ['dff'],
        'audio/x-dsd': ['dsf'],
        'audio/x-dsf': ['dsf'],
        'audio/x-dsp': ['dsm', 'dsp'],
        'audio/x-dts': ['dts'],
        'audio/x-dtshd': ['dtshd'],
        'audio/x-flac': ['flac'],
        'audio/x-flac+ogg': ['oga', 'ogg'],
        'audio/x-gsm': ['gsm'],
        'audio/x-hx-aac-adts': ['aac', 'adts', 'ass'],
        'audio/x-imelody': ['imy', 'ime'],
        'audio/x-iriver-pla': ['pla'],
        'audio/x-it': ['it'],
        'audio/x-m3u': ['m3u', 'm3u8', 'vlc'],
        'audio/x-m4a': ['m4a', 'f4a'],
        'audio/x-m4b': ['m4b', 'f4b'],
        'audio/x-m4r': ['m4r'],
        'audio/x-matroska': ['mka'],
        'audio/x-med': ['med'],
        'audio/x-midi': ['mid', 'midi', 'kar'],
        'audio/x-minipsf': ['minipsf'],
        'audio/x-mo3': ['mo3'],
        'audio/x-mod': ['mod', 'm15', 'stk', 'nst', 'fst', '669', 'med'],
        'audio/x-mp2': ['mp2'],
        'audio/x-mp3': ['mp3', 'mpga'],
        'audio/x-mp3-playlist': ['m3u', 'm3u8', 'vlc'],
        'audio/x-mpeg': ['mp3', 'mpga'],
        'audio/x-mpegurl': ['m3u', 'm3u8', 'vlc'],
        'audio/x-mpg': ['mp3', 'mpga'],
        'audio/x-ms-asx': ['asx', 'wax', 'wvx', 'wmx'],
        'audio/x-ms-wax': ['wax'],
        'audio/x-ms-wma': ['wma'],
        'audio/x-ms-wmv': ['wmv'],
        'audio/x-mtm': ['mtm'],
        'audio/x-multimate-mod': ['ult'],
        'audio/x-multitrack': ['mtm'],
        'audio/x-musepack': ['mpc', 'mpp', 'mp+'],
        'audio/x-ogg': ['oga', 'ogg', 'opus'],
        'audio/x-oggflac': ['oga', 'ogg'],
        'audio/x-opus+ogg': ['opus'],
        'audio/x-pn-audibleaudio': ['aa', 'aax'],
        'audio/x-pn-realaudio': ['ram', 'ra', 'rax'],
        'audio/x-pn-realaudio-plugin': ['rmp'],
        'audio/x-psf': ['psf'],
        'audio/x-psflib': ['psflib'],
        'audio/x-realaudio': ['ra'],
        'audio/x-rn-3gpp-amr': ['3gp', '3gpp', '3ga'],
        'audio/x-rn-3gpp-amr-encrypted': ['3gp', '3gpp', '3ga'],
        'audio/x-rn-3gpp-amr-wb': ['3gp', '3gpp', '3ga'],
        'audio/x-rn-3gpp-amr-wb-encrypted': ['3gp', '3gpp', '3ga'],
        'audio/x-s3m': ['s3m'],
        'audio/x-scpls': ['pls'],
        'audio/x-shorten': ['shn'],
        'audio/x-speex': ['spx'],
        'audio/x-speex+ogg': ['oga', 'ogg', 'spx'],
        'audio/x-stm': ['stm'],
        'audio/x-tak': ['tak'],
        'audio/x-tta': ['tta'],
        'audio/x-ult': ['ult'],
        'audio/x-voc': ['voc'],
        'audio/x-vorbis': ['oga', 'ogg'],
        'audio/x-vorbis+ogg': ['oga', 'ogg'],
        'audio/x-wav': ['wav'],
        'audio/x-wavpack': ['wv', 'wvp'],
        'audio/x-wavpack-correction': ['wvc'],
        'audio/x-xi': ['xi'],
        'audio/x-xm': ['xm'],
        'audio/x-xmf': ['xmf'],
        'audio/x.sf3': ['au.sf3', 'sf3'],
        'audio/xm': ['xm'],
        'audio/xmf': ['xmf'],
        'chemical/x-cdx': ['cdx'],
        'chemical/x-cif': ['cif'],
        'chemical/x-cmdf': ['cmdf'],
        'chemical/x-cml': ['cml'],
        'chemical/x-csml': ['csml'],
        'chemical/x-pdb': ['pdb', 'brk'],
        'chemical/x-xyz': ['xyz'],
        'flv-application/octet-stream': ['flv'],
        'font/collection': ['ttc'],
        'font/otf': ['otf'],
        'font/ttf': ['ttf'],
        'font/woff': ['woff'],
        'font/woff2': ['woff2'],
        'image/aces': ['exr'],
        'image/apng': ['apng', 'png'],
        'image/astc': ['astc'],
        'image/avci': ['avci'],
        'image/avcs': ['avcs'],
        'image/avif': ['avif', 'avifs'],
        'image/avif-sequence': ['avif', 'avifs'],
        'image/bmp': ['bmp', 'dib'],
        'image/cdr': ['cdr'],
        'image/cgm': ['cgm'],
        'image/dicom-rle': ['drle'],
        'image/dpx': ['dpx'],
        'image/emf': ['emf'],
        'image/fax-g3': ['g3'],
        'image/fits': ['fits', 'fit', 'fts'],
        'image/g3fax': ['g3'],
        'image/gif': ['gif'],
        'image/heic': ['heic', 'heif', 'hif'],
        'image/heic-sequence': ['heics', 'heic', 'heif', 'hif'],
        'image/heif': ['heif', 'heic', 'hif'],
        'image/heif-sequence': ['heifs', 'heic', 'heif', 'hif'],
        'image/hej2k': ['hej2'],
        'image/hsj2': ['hsj2'],
        'image/ico': ['ico'],
        'image/icon': ['ico'],
        'image/ief': ['ief'],
        'image/jls': ['jls'],
        'image/jp2': ['jp2', 'jpg2'],
        'image/jpeg': ['jpg', 'jpeg', 'jpe', 'jfif'],
        'image/jpeg2000': ['jp2', 'jpg2'],
        'image/jpeg2000-image': ['jp2', 'jpg2'],
        'image/jph': ['jph'],
        'image/jphc': ['jhc'],
        'image/jpm': ['jpm', 'jpgm'],
        'image/jpx': ['jpx', 'jpf'],
        'image/jxl': ['jxl'],
        'image/jxr': ['jxr', 'hdp', 'wdp'],
        'image/jxra': ['jxra'],
        'image/jxrs': ['jxrs'],
        'image/jxs': ['jxs'],
        'image/jxsc': ['jxsc'],
        'image/jxsi': ['jxsi'],
        'image/jxss': ['jxss'],
        'image/ktx': ['ktx'],
        'image/ktx2': ['ktx2'],
        'image/openraster': ['ora'],
        'image/pdf': ['pdf'],
        'image/photoshop': ['psd'],
        'image/pjpeg': ['jpg', 'jpeg', 'jpe', 'jfif'],
        'image/png': ['png'],
        'image/prs.btif': ['btif', 'btf'],
        'image/prs.pti': ['pti'],
        'image/psd': ['psd'],
        'image/qoi': ['qoi'],
        'image/rle': ['rle'],
        'image/sgi': ['sgi'],
        'image/svg': ['svg'],
        'image/svg+xml': ['svg', 'svgz'],
        'image/svg+xml-compressed': ['svgz', 'svg.gz'],
        'image/t38': ['t38'],
        'image/targa': ['tga', 'icb', 'tpic', 'vda', 'vst'],
        'image/tga': ['tga', 'icb', 'tpic', 'vda', 'vst'],
        'image/tiff': ['tif', 'tiff'],
        'image/tiff-fx': ['tfx'],
        'image/vnd.adobe.photoshop': ['psd'],
        'image/vnd.airzip.accelerator.azv': ['azv'],
        'image/vnd.dece.graphic': ['uvi', 'uvvi', 'uvg', 'uvvg'],
        'image/vnd.djvu': ['djvu', 'djv'],
        'image/vnd.djvu+multipage': ['djvu', 'djv'],
        'image/vnd.dvb.subtitle': ['sub'],
        'image/vnd.dwg': ['dwg'],
        'image/vnd.dxf': ['dxf'],
        'image/vnd.fastbidsheet': ['fbs'],
        'image/vnd.fpx': ['fpx'],
        'image/vnd.fst': ['fst'],
        'image/vnd.fujixerox.edmics-mmr': ['mmr'],
        'image/vnd.fujixerox.edmics-rlc': ['rlc'],
        'image/vnd.microsoft.icon': ['ico'],
        'image/vnd.mozilla.apng': ['apng', 'png'],
        'image/vnd.ms-dds': ['dds'],
        'image/vnd.ms-modi': ['mdi'],
        'image/vnd.ms-photo': ['wdp', 'jxr', 'hdp'],
        'image/vnd.net-fpx': ['npx'],
        'image/vnd.pco.b16': ['b16'],
        'image/vnd.radiance': ['hdr', 'pic', 'rgbe', 'xyze'],
        'image/vnd.rn-realpix': ['rp'],
        'image/vnd.tencent.tap': ['tap'],
        'image/vnd.valve.source.texture': ['vtf'],
        'image/vnd.wap.wbmp': ['wbmp'],
        'image/vnd.xiff': ['xif'],
        'image/vnd.zbrush.pcx': ['pcx'],
        'image/webp': ['webp'],
        'image/wmf': ['wmf'],
        'image/x-3ds': ['3ds'],
        'image/x-adobe-dng': ['dng'],
        'image/x-applix-graphics': ['ag'],
        'image/x-bmp': ['bmp', 'dib'],
        'image/x-bzeps': ['eps.bz2', 'epsi.bz2', 'epsf.bz2'],
        'image/x-canon-cr2': ['cr2'],
        'image/x-canon-cr3': ['cr3'],
        'image/x-canon-crw': ['crw'],
        'image/x-cdr': ['cdr'],
        'image/x-cmu-raster': ['ras'],
        'image/x-cmx': ['cmx'],
        'image/x-compressed-xcf': ['xcf.gz', 'xcf.bz2'],
        'image/x-dds': ['dds'],
        'image/x-djvu': ['djvu', 'djv'],
        'image/x-emf': ['emf'],
        'image/x-eps': ['eps', 'epsi', 'epsf'],
        'image/x-exr': ['exr'],
        'image/x-fits': ['fits', 'fit', 'fts'],
        'image/x-fpx': ['fpx'],
        'image/x-freehand': ['fh', 'fhc', 'fh4', 'fh5', 'fh7'],
        'image/x-fuji-raf': ['raf'],
        'image/x-gimp-gbr': ['gbr'],
        'image/x-gimp-gih': ['gih'],
        'image/x-gimp-pat': ['pat'],
        'image/x-gzeps': ['eps.gz', 'epsi.gz', 'epsf.gz'],
        'image/x-hdr': ['hdr', 'pic', 'rgbe', 'xyze'],
        'image/x-icb': ['tga', 'icb', 'tpic', 'vda', 'vst'],
        'image/x-icns': ['icns'],
        'image/x-ico': ['ico'],
        'image/x-icon': ['ico'],
        'image/x-iff': ['iff', 'ilbm', 'lbm'],
        'image/x-ilbm': ['iff', 'ilbm', 'lbm'],
        'image/x-jng': ['jng'],
        'image/x-jp2-codestream': ['j2c', 'j2k', 'jpc'],
        'image/x-jpeg2000-image': ['jp2', 'jpg2'],
        'image/x-kiss-cel': ['cel', 'kcf'],
        'image/x-kodak-dcr': ['dcr'],
        'image/x-kodak-k25': ['k25'],
        'image/x-kodak-kdc': ['kdc'],
        'image/x-lwo': ['lwo', 'lwob'],
        'image/x-lws': ['lws'],
        'image/x-macpaint': ['pntg'],
        'image/x-minolta-mrw': ['mrw'],
        'image/x-mrsid-image': ['sid'],
        'image/x-ms-bmp': ['bmp', 'dib'],
        'image/x-msod': ['msod'],
        'image/x-nikon-nef': ['nef'],
        'image/x-nikon-nrw': ['nrw'],
        'image/x-olympus-orf': ['orf'],
        'image/x-panasonic-raw': ['raw'],
        'image/x-panasonic-raw2': ['rw2'],
        'image/x-panasonic-rw': ['raw'],
        'image/x-panasonic-rw2': ['rw2'],
        'image/x-pcx': ['pcx'],
        'image/x-pentax-pef': ['pef'],
        'image/x-pfm': ['pfm'],
        'image/x-phm': ['phm'],
        'image/x-photo-cd': ['pcd'],
        'image/x-photoshop': ['psd'],
        'image/x-pict': ['pic', 'pct', 'pict', 'pict1', 'pict2'],
        'image/x-portable-anymap': ['pnm'],
        'image/x-portable-bitmap': ['pbm'],
        'image/x-portable-graymap': ['pgm'],
        'image/x-portable-pixmap': ['ppm'],
        'image/x-psd': ['psd'],
        'image/x-pxr': ['pxr'],
        'image/x-quicktime': ['qtif', 'qif'],
        'image/x-rgb': ['rgb'],
        'image/x-sct': ['sct'],
        'image/x-sgi': ['sgi'],
        'image/x-sigma-x3f': ['x3f'],
        'image/x-skencil': ['sk', 'sk1'],
        'image/x-sony-arw': ['arw'],
        'image/x-sony-sr2': ['sr2'],
        'image/x-sony-srf': ['srf'],
        'image/x-sun-raster': ['sun'],
        'image/x-targa': ['tga', 'icb', 'tpic', 'vda', 'vst'],
        'image/x-tga': ['tga', 'icb', 'tpic', 'vda', 'vst'],
        'image/x-win-bitmap': ['cur'],
        'image/x-win-metafile': ['wmf'],
        'image/x-wmf': ['wmf'],
        'image/x-xbitmap': ['xbm'],
        'image/x-xcf': ['xcf'],
        'image/x-xfig': ['fig'],
        'image/x-xpixmap': ['xpm'],
        'image/x-xpm': ['xpm'],
        'image/x-xwindowdump': ['xwd'],
        'image/x.djvu': ['djvu', 'djv'],
        'image/x.sf3': ['img.sf3', 'sf3'],
        'image/x.sf3-vector': ['vec.sf3', 'sf3'],
        'message/disposition-notification': ['disposition-notification'],
        'message/global': ['u8msg'],
        'message/global-delivery-status': ['u8dsn'],
        'message/global-disposition-notification': ['u8mdn'],
        'message/global-headers': ['u8hdr'],
        'message/rfc822': ['eml', 'mime'],
        'message/vnd.wfa.wsc': ['wsc'],
        'model/3mf': ['3mf'],
        'model/gltf+json': ['gltf'],
        'model/gltf-binary': ['glb'],
        'model/iges': ['igs', 'iges'],
        'model/jt': ['jt'],
        'model/mesh': ['msh', 'mesh', 'silo'],
        'model/mtl': ['mtl'],
        'model/obj': ['obj'],
        'model/prc': ['prc'],
        'model/step': ['step', 'stp'],
        'model/step+xml': ['stpx'],
        'model/step+zip': ['stpz'],
        'model/step-xml+zip': ['stpxz'],
        'model/stl': ['stl'],
        'model/u3d': ['u3d'],
        'model/vnd.bary': ['bary'],
        'model/vnd.cld': ['cld'],
        'model/vnd.collada+xml': ['dae'],
        'model/vnd.dwf': ['dwf'],
        'model/vnd.gdl': ['gdl'],
        'model/vnd.gtw': ['gtw'],
        'model/vnd.mts': ['mts'],
        'model/vnd.opengex': ['ogex'],
        'model/vnd.parasolid.transmit.binary': ['x_b'],
        'model/vnd.parasolid.transmit.text': ['x_t'],
        'model/vnd.pytha.pyox': ['pyo', 'pyox'],
        'model/vnd.sap.vds': ['vds'],
        'model/vnd.usda': ['usda'],
        'model/vnd.usdz+zip': ['usdz'],
        'model/vnd.valve.source.compiled-map': ['bsp'],
        'model/vnd.vtu': ['vtu'],
        'model/vrml': ['wrl', 'vrml', 'vrm'],
        'model/x.sf3': ['mod.sf3', 'sf3'],
        'model/x.sf3-physics': ['phys.sf3', 'sf3'],
        'model/x.stl-ascii': ['stl'],
        'model/x.stl-binary': ['stl'],
        'model/x3d+binary': ['x3db', 'x3dbz'],
        'model/x3d+fastinfoset': ['x3db'],
        'model/x3d+vrml': ['x3dv', 'x3dvz'],
        'model/x3d+xml': ['x3d', 'x3dz'],
        'model/x3d-vrml': ['x3dv'],
        'text/cache-manifest': ['appcache', 'manifest'],
        'text/calendar': ['ics', 'ifb', 'vcs', 'icalendar'],
        'text/coffeescript': ['coffee', 'litcoffee'],
        'text/crystal': ['cr'],
        'text/css': ['css'],
        'text/csv': ['csv'],
        'text/csv-schema': ['csvs'],
        'text/directory': ['vcard', 'vcf', 'vct', 'gcrd'],
        'text/ecmascript': ['es'],
        'text/gedcom': ['ged', 'gedcom'],
        'text/google-video-pointer': ['gvp'],
        'text/html': ['html', 'htm', 'shtml'],
        'text/ico': ['ico'],
        'text/jade': ['jade'],
        'text/javascript': ['js', 'mjs', 'cjs', 'jsm'],
        'text/jscript': ['cjs', 'js', 'jsm', 'mjs'],
        'text/jscript.encode': ['jse'],
        'text/jsx': ['jsx'],
        'text/julia': ['jl'],
        'text/less': ['less'],
        'text/markdown': ['md', 'markdown', 'mkd'],
        'text/mathml': ['mml'],
        'text/mdx': ['mdx'],
        'text/n3': ['n3'],
        'text/org': ['org'],
        'text/plain': [
            'txt',
            'text',
            'conf',
            'def',
            'list',
            'log',
            'in',
            'ini',
            'asc',
        ],
        'text/prs.lines.tag': ['dsc'],
        'text/rdf': ['rdf', 'rdfs', 'owl'],
        'text/richtext': ['rtx'],
        'text/rss': ['rss'],
        'text/rtf': ['rtf'],
        'text/rust': ['rs'],
        'text/sgml': ['sgml', 'sgm'],
        'text/shex': ['shex'],
        'text/slim': ['slim', 'slm'],
        'text/spdx': ['spdx'],
        'text/spreadsheet': ['sylk', 'slk'],
        'text/stylus': ['stylus', 'styl'],
        'text/tab-separated-values': ['tsv'],
        'text/tcl': ['tcl', 'tk'],
        'text/troff': ['t', 'tr', 'roff', 'man', 'me', 'ms'],
        'text/turtle': ['ttl'],
        'text/uri-list': ['uri', 'uris', 'urls'],
        'text/vbs': ['vbs'],
        'text/vbscript': ['vbs'],
        'text/vbscript.encode': ['vbe'],
        'text/vcard': ['vcard', 'vcf', 'vct', 'gcrd'],
        'text/vnd.curl': ['curl'],
        'text/vnd.curl.dcurl': ['dcurl'],
        'text/vnd.curl.mcurl': ['mcurl'],
        'text/vnd.curl.scurl': ['scurl'],
        'text/vnd.dvb.subtitle': ['sub'],
        'text/vnd.familysearch.gedcom': ['ged', 'gedcom'],
        'text/vnd.fly': ['fly'],
        'text/vnd.fmi.flexstor': ['flx'],
        'text/vnd.graphviz': ['gv', 'dot'],
        'text/vnd.in3d.3dml': ['3dml'],
        'text/vnd.in3d.spot': ['spot'],
        'text/vnd.qt.linguist': ['ts'],
        'text/vnd.rn-realtext': ['rt'],
        'text/vnd.senx.warpscript': ['mc2'],
        'text/vnd.sun.j2me.app-descriptor': ['jad'],
        'text/vnd.trolltech.linguist': ['ts'],
        'text/vnd.typst': ['typ'],
        'text/vnd.wap.wml': ['wml'],
        'text/vnd.wap.wmlscript': ['wmls'],
        'text/vtt': ['vtt'],
        'text/wgsl': ['wgsl'],
        'text/x-adasrc': ['adb', 'ads'],
        'text/x-asm': ['s', 'asm'],
        'text/x-basic': ['bas'],
        'text/x-bibtex': ['bib'],
        'text/x-blueprint': ['blp'],
        'text/x-c': ['c', 'cc', 'cxx', 'cpp', 'h', 'hh', 'dic'],
        'text/x-c++hdr': ['hh', 'hp', 'hpp', 'h++', 'hxx'],
        'text/x-c++src': ['cpp', 'cxx', 'cc', 'C', 'c++'],
        'text/x-chdr': ['h'],
        'text/x-cmake': ['cmake'],
        'text/x-cobol': ['cbl', 'cob'],
        'text/x-comma-separated-values': ['csv'],
        'text/x-common-lisp': ['asd', 'fasl', 'lisp', 'ros'],
        'text/x-component': ['htc'],
        'text/x-crystal': ['cr'],
        'text/x-csharp': ['cs'],
        'text/x-csrc': ['c'],
        'text/x-csv': ['csv'],
        'text/x-cython': ['pxd', 'pxi', 'pyx'],
        'text/x-dart': ['dart'],
        'text/x-dbus-service': ['service'],
        'text/x-dcl': ['dcl'],
        'text/x-devicetree-binary': ['dtb'],
        'text/x-devicetree-source': ['dts', 'dtsi'],
        'text/x-diff': ['diff', 'patch'],
        'text/x-dockerfile': ['Dockerfile'],
        'text/x-dsl': ['dsl'],
        'text/x-dsrc': ['d', 'di'],
        'text/x-dtd': ['dtd'],
        'text/x-eiffel': ['e', 'eif'],
        'text/x-elixir': ['ex', 'exs'],
        'text/x-emacs-lisp': ['el'],
        'text/x-erlang': ['erl'],
        'text/x-fish': ['fish'],
        'text/x-fortran': ['f', 'for', 'f77', 'f90', 'f95'],
        'text/x-gcode-gx': ['gx'],
        'text/x-genie': ['gs'],
        'text/x-gettext-translation': ['po'],
        'text/x-gettext-translation-template': ['pot'],
        'text/x-gherkin': ['feature'],
        'text/x-go': ['go'],
        'text/x-google-video-pointer': ['gvp'],
        'text/x-gradle': ['gradle'],
        'text/x-groovy': ['groovy', 'gvy', 'gy', 'gsh'],
        'text/x-handlebars-template': ['hbs'],
        'text/x-haskell': ['hs'],
        'text/x-idl': ['idl'],
        'text/x-imelody': ['imy', 'ime'],
        'text/x-iptables': ['iptables'],
        'text/x-java': ['java'],
        'text/x-java-source': ['java'],
        'text/x-kaitai-struct': ['ksy'],
        'text/x-kotlin': ['kt'],
        'text/x-ldif': ['ldif'],
        'text/x-lilypond': ['ly'],
        'text/x-literate-haskell': ['lhs'],
        'text/x-log': ['log'],
        'text/x-lua': ['lua'],
        'text/x-lyx': ['lyx'],
        'text/x-makefile': ['mk', 'mak'],
        'text/x-markdown': ['md', 'mkd', 'markdown'],
        'text/x-matlab': ['m'],
        'text/x-microdvd': ['sub'],
        'text/x-moc': ['moc'],
        'text/x-modelica': ['mo'],
        'text/x-mof': ['mof'],
        'text/x-mpl2': ['mpl'],
        'text/x-mpsub': ['sub'],
        'text/x-mrml': ['mrml', 'mrl'],
        'text/x-ms-regedit': ['reg'],
        'text/x-ms-visualstudio.project': ['dsp'],
        'text/x-ms-visualstudio.workspace': ['dsw'],
        'text/x-mup': ['mup', 'not'],
        'text/x-nfo': ['nfo'],
        'text/x-nim': ['nim'],
        'text/x-nimscript': ['nims', 'nimble'],
        'text/x-nix': ['nix'],
        'text/x-nsis': ['nsi', 'nsh'],
        'text/x-nu': ['nu'],
        'text/x-nushell': ['nu'],
        'text/x-objc++src': ['mm'],
        'text/x-objcsrc': ['m'],
        'text/x-ocaml': ['ml', 'mli'],
        'text/x-ocl': ['ocl'],
        'text/x-octave': ['m'],
        'text/x-ooc': ['ooc'],
        'text/x-opencl-c++src': ['clcpp'],
        'text/x-opencl-csrc': ['cl'],
        'text/x-opencl-src': ['cl'],
        'text/x-opml': ['opml'],
        'text/x-opml+xml': ['opml'],
        'text/x-org': ['org'],
        'text/x-pascal': ['p', 'pas'],
        'text/x-patch': ['diff', 'patch'],
        'text/x-perl': ['pl', 'PL', 'pm', 'al', 'perl', 'pod', 't'],
        'text/x-po': ['po'],
        'text/x-pot': ['pot'],
        'text/x-processing': ['pde'],
        'text/x-python': ['py', 'wsgi'],
        'text/x-python2': ['py', 'py2'],
        'text/x-python3': ['py', 'py3', 'pyi'],
        'text/x-qml': ['qml', 'qmltypes', 'qmlproject'],
        'text/x-reject': ['rej'],
        'text/x-rpm-spec': ['spec'],
        'text/x-rst': ['rst'],
        'text/x-ruby': ['rb'],
        'text/x-sagemath': ['sage'],
        'text/x-sass': ['sass'],
        'text/x-scala': ['scala', 'sc'],
        'text/x-scheme': ['scm', 'ss'],
        'text/x-scss': ['scss'],
        'text/x-setext': ['etx'],
        'text/x-sfv': ['sfv'],
        'text/x-sh': ['sh'],
        'text/x-sql': ['sql'],
        'text/x-ssa': ['ssa', 'ass'],
        'text/x-ssh-public-key': ['pub'],
        'text/x-subviewer': ['sub'],
        'text/x-suse-ymp': ['ymp'],
        'text/x-svhdr': ['svh'],
        'text/x-svsrc': ['sv'],
        'text/x-systemd-unit': [
            'automount',
            'device',
            'mount',
            'path',
            'scope',
            'service',
            'slice',
            'socket',
            'swap',
            'target',
            'timer',
        ],
        'text/x-tcl': ['tcl', 'tk'],
        'text/x-tex': ['tex', 'ltx', 'sty', 'cls', 'dtx', 'ins', 'latex'],
        'text/x-texinfo': ['texi', 'texinfo'],
        'text/x-troff': ['tr', 'roff', 't'],
        'text/x-troff-me': ['me'],
        'text/x-troff-mm': ['mm'],
        'text/x-troff-ms': ['ms'],
        'text/x-twig': ['twig'],
        'text/x-txt2tags': ['t2t'],
        'text/x-typst': ['typ'],
        'text/x-uil': ['uil'],
        'text/x-uuencode': ['uu', 'uue'],
        'text/x-vala': ['vala', 'vapi'],
        'text/x-vb': ['vb'],
        'text/x-vcalendar': ['vcs', 'ics', 'ifb', 'icalendar'],
        'text/x-vcard': ['vcf', 'vcard', 'vct', 'gcrd'],
        'text/x-verilog': ['v'],
        'text/x-vhdl': ['vhd', 'vhdl'],
        'text/x-xmi': ['xmi'],
        'text/x-xslfo': ['fo', 'xslfo'],
        'text/x-yaml': ['yaml', 'yml'],
        'text/x.gcode': ['gcode'],
        'text/xml': ['xml', 'xbl', 'xsd', 'rng'],
        'text/xml-external-parsed-entity': ['ent'],
        'text/yaml': ['yaml', 'yml'],
        'video/3gp': ['3gp', '3gpp', '3ga'],
        'video/3gpp': ['3gp', '3gpp', '3ga'],
        'video/3gpp-encrypted': ['3gp', '3gpp', '3ga'],
        'video/3gpp2': ['3g2', '3gp2', '3gpp2'],
        'video/annodex': ['axv'],
        'video/avi': ['avi', 'avf', 'divx'],
        'video/divx': ['avi', 'avf', 'divx'],
        'video/dv': ['dv'],
        'video/fli': ['fli', 'flc'],
        'video/flv': ['flv'],
        'video/h261': ['h261'],
        'video/h263': ['h263'],
        'video/h264': ['h264'],
        'video/iso.segment': ['m4s'],
        'video/jpeg': ['jpgv'],
        'video/jpm': ['jpm', 'jpgm'],
        'video/matroska': ['mkv', 'mks', 'mk3d'],
        'video/mj2': ['mj2', 'mjp2'],
        'video/mp2t': [
            'ts',
            'm2t',
            'm2ts',
            'mts',
            'cpi',
            'clpi',
            'mpl',
            'mpls',
            'bdm',
            'bdmv',
        ],
        'video/mp4': ['mp4', 'mp4v', 'mpg4', 'm4v', 'f4v', 'lrv', 'lrf'],
        'video/mp4v-es': ['mp4', 'm4v', 'f4v', 'lrv', 'lrf'],
        'video/mpeg': ['mpeg', 'mpg', 'mpe', 'm1v', 'm2v', 'mp2', 'vob'],
        'video/mpeg-system': ['mpeg', 'mpg', 'mp2', 'mpe', 'vob'],
        'video/mpg4': ['mpg4'],
        'video/msvideo': ['avi', 'avf', 'divx'],
        'video/ogg': ['ogv', 'ogg'],
        'video/quicktime': ['mov', 'qt', 'moov', 'qtvr'],
        'video/vivo': ['viv', 'vivo'],
        'video/vnd.avi': ['avi', 'avf', 'divx'],
        'video/vnd.dece.hd': ['uvh', 'uvvh'],
        'video/vnd.dece.mobile': ['uvm', 'uvvm'],
        'video/vnd.dece.pd': ['uvp', 'uvvp'],
        'video/vnd.dece.sd': ['uvs', 'uvvs'],
        'video/vnd.dece.video': ['uvv', 'uvvv'],
        'video/vnd.divx': ['avi', 'avf', 'divx'],
        'video/vnd.dvb.file': ['dvb'],
        'video/vnd.fvt': ['fvt'],
        'video/vnd.mpegurl': ['mxu', 'm4u', 'm1u'],
        'video/vnd.ms-playready.media.pyv': ['pyv'],
        'video/vnd.radgamettools.bink': ['bik', 'bk2'],
        'video/vnd.radgamettools.smacker': ['smk'],
        'video/vnd.rn-realvideo': ['rv', 'rvx'],
        'video/vnd.uvvu.mp4': ['uvu', 'uvvu'],
        'video/vnd.vivo': ['viv', 'vivo'],
        'video/vnd.youtube.yt': ['yt'],
        'video/webm': ['webm'],
        'video/x-anim': [
            'anim[1-9j]',
            'anim2',
            'anim3',
            'anim4',
            'anim5',
            'anim6',
            'anim7',
            'anim8',
            'anim9',
            'animj',
        ],
        'video/x-annodex': ['axv'],
        'video/x-avi': ['avi', 'avf', 'divx'],
        'video/x-f4v': ['f4v'],
        'video/x-fli': ['fli', 'flc'],
        'video/x-flic': ['fli', 'flc'],
        'video/x-flv': ['flv'],
        'video/x-javafx': ['fxm'],
        'video/x-m4v': ['m4v', 'mp4', 'f4v', 'lrv', 'lrf'],
        'video/x-matroska': ['mkv', 'mk3d', 'mks'],
        'video/x-matroska-3d': ['mk3d'],
        'video/x-mjpeg': ['mjpeg', 'mjpg'],
        'video/x-mng': ['mng'],
        'video/x-mpeg': ['mpeg', 'mpg', 'mp2', 'mpe', 'vob'],
        'video/x-mpeg-system': ['mpeg', 'mpg', 'mp2', 'mpe', 'vob'],
        'video/x-mpeg2': ['mpeg', 'mpg', 'mp2', 'mpe', 'vob'],
        'video/x-mpegurl': ['m1u', 'm4u', 'mxu'],
        'video/x-ms-asf': ['asf', 'asx'],
        'video/x-ms-asf-plugin': ['asf'],
        'video/x-ms-vob': ['vob'],
        'video/x-ms-wax': ['asx', 'wax', 'wvx', 'wmx'],
        'video/x-ms-wm': ['wm', 'asf'],
        'video/x-ms-wmv': ['wmv'],
        'video/x-ms-wmx': ['wmx', 'asx', 'wax', 'wvx'],
        'video/x-ms-wvx': ['wvx', 'asx', 'wax', 'wmx'],
        'video/x-msvideo': ['avi', 'avf', 'divx'],
        'video/x-nsv': ['nsv'],
        'video/x-ogg': ['ogv', 'ogg'],
        'video/x-ogm': ['ogm'],
        'video/x-ogm+ogg': ['ogm'],
        'video/x-real-video': ['rv', 'rvx'],
        'video/x-sgi-movie': ['movie'],
        'video/x-smv': ['smv'],
        'video/x-theora': ['ogg'],
        'video/x-theora+ogg': ['ogg'],
        'x-conference/x-cooltalk': ['ice'],
        'x-epoc/x-sisx-app': ['sisx'],
        'zz-application/zz-winassoc-123': ['123', 'wk1', 'wk3', 'wk4', 'wks'],
        'zz-application/zz-winassoc-cab': ['cab'],
        'zz-application/zz-winassoc-cdr': ['cdr'],
        'zz-application/zz-winassoc-doc': ['doc'],
        'zz-application/zz-winassoc-hlp': ['hlp'],
        'zz-application/zz-winassoc-mdb': ['mdb'],
        'zz-application/zz-winassoc-uu': ['uue'],
        'zz-application/zz-winassoc-xls': [
            'xls',
            'xlc',
            'xll',
            'xlm',
            'xlw',
            'xla',
            'xlt',
            'xld',
        ],
    };
}

export function getMIMETypeFromFile(file: File): string | undefined {
    if (file.type) {
        return file.type;
    }

    const extension = getExtensionFromFilename(file.name);

    return getMIMETypeFromExtension(extension);
}

export function getMIMETypeFromExtension(
    extension: string | undefined
): string | undefined {
    if (!extension) {
        return;
    }
    const mimeTypes = getMimeTypesMap();
    for (const [type, extensions] of Object.entries(mimeTypes)) {
        if (extensions.includes(extension)) {
            return type;
        }
    }
}

export function getExtensionFromMIMEType(
    type: string | undefined
): string | undefined {
    if (!type) {
        return;
    }
    const extensions = getMimeTypesMap()[type];
    if (!extensions) {
        return;
    }

    return extensions[0];
}
